// 斯洛文尼亚语
import slLocale from 'element-ui/lib/locale/lang/sl'


const sl = {
  // ============== 登陆页 start=============
  "登录": "Prijava",
  "退出": "Odjava",
  "账号": "Račun",
  "密码": "Geslo",
  "验证码": "Preverjanje kode",
  "请输入账号": "Prosim vnesite svoj račun",
  "请输入密码": "Prosim vnesite svoje geslo",
  "请输入验证码": "Prosim vnesite preverjanje kode",
  "验证码不正确": "Napačna preverjanje koda",
  "没有账号": "Ni računa",
  "请": "Prosim",
  "点击注册": "Kliknite za registracijo",
  // ============== 登陆页 end  =============
  // =========== 首页 start==================
  "门店总量": "Skupno število trgovin",
  "用户总量": "Skupno število uporabnikov",
  "营业总量": "Skupno poslovno obratovanje",
  "订单总量": "Skupno število naročil",
  "商品总量": "Skupno število inventarja",
  "销售总额": "Skupna prodaja",
  "元": "€",
  "预计收入": "Predviden dohodek",
  "今日概况": "Današnji povzetek",
  "销售额": "Obseg prodaje",
  "支付订单数": "Plačanih naročil",
  "昨日": "Včeraj",
  "新增用户数": "Novi uporabniki",
  "新增商户": "Novi trgovci",
  "下单用户数": "Uporabniki, ki oddajajo naročila",
  "待办事项": "Naloge za izvedbo",
  "请尽快处理，以免影响营业": "Prosimo, čim prej odpravite, da ne bo vplivalo na poslovanje",
  "待处理订单": "Naročila v obdelavi",
  "库存告急": "Zasilna zaloga",
  "商品排行榜": "Seznam najboljših izdelkov",
  "销量": "Obseg prodaje",
  "暂无上榜记录": "Trenutno ni podatkov na seznamu",
  "成交额": "Volumen transakcij",
  "成交量": "Število transakcij",
  "退单额": "Skupen znesek vračil",
  "退单量": "Število vračil",
  // =========== 首页 end==================
  // =========== 建店必做 start=============
  "基本资料": "Osnovne informacije",
  "编辑门店": "Uredi trgovino",
  "官方网站": "Uradna spletna stran",
  "门店服务": "Storitve trgovine",
  "服务与营业时间": "Storitve in delovni čas",
  "收银台": "Blagajna",
  "后厨": "Kuhinja",
  "商品": "Blago",
  "商品分类": "Klasifikacija blaga",
  "添加商品": "Dodaj blago",
  "网站": "Spletna stran",
  "网站编辑": "Ureditev spletne strani",
  "上一步": "Prejšnji korak",
  "保存": "Shrani",
  "下一步": "Naslednji korak",
  "提交失败": "Neuspešno oddajanje",
  "获取当前进度信息失败": "Neuspešen doseg trenutnega napredka",
  "门店名称": "Ime trgovine",
  "请输入门店名称": "Prosim vnesite ime trgovine",
  "登录密码": "Prijava geslo",
  "请输入登录密码": "Prosim vnesite geslo za prijavo",
  "确认密码": "Potrdi geslo",
  "请输入确认密码": "Prosim vnesite potrditev gesla",
  "联系人": "Kontakt",
  "请输入联系人": "Prosim vnesite ime kontaktne osebe",
  "请输入联系电话": "Prosim vnesite kontaktno telefonsko številko",
  "店铺类型": "Vrsta trgovine",
  "分店": "Podružnica",
  "直营": "Direktna prodaja",
  "同步主店": "Sinhronizacija s glavno trgovino",
  "分店创建": "Ustvarjanje podružnice",
  "温馨提示：选择后，请勿随意修改，以免造成门店商品数据错乱": "Topel spomin: Po izbiri ne spreminjajte naključno, da ne bi prišlo do zmede pri podatkih o blagu trgovine",
  "绑定用户": "Poveži uporabnika",
  "选择用户": "Izberi uporabnika",
  "用户昵称": "Vzdevek uporabnika",
  "选择图片": "Izberi sliko",
  "地址": "Naslov",
  "请输入地址": "Prosim vnesite naslov",
  "门店坐标": "Koordinate trgovine",
  "商家介绍": "Predstavitev trgovca",
  "状态": "Status",
  "开启": "Odpri",
  "禁止": "Zaprto",
  "营业状态": "Poslovni status",
  "营业中": "Odpri",
  "停止营业": "Zaprto",
  "上传图片": "Naloži sliko",
  "获取当前门店失败，请刷新界面重试": "Neuspešno pridobivanje trenutne trgovine, prosim osvežite stran in poskusite znova",
  "商城名称": "Ime trgovine",
  "商城名称不能为空": "Ime trgovine ne sme biti prazno",
  "访问网址后缀": "Dodatek naslovne povezave",
  "访问网址": "Obišči URL",
  "手机网站": "Mobilna spletna stran",
  "默认": "Privzeto",
  "自定义": "Po meri",
  "Pad点餐网站": "Pad naročilna spletna stran",
  "收银台网站": "Blagajna spletna stran",
  "后厨网站": "Kuhinjska spletna stran",
  "会员设置": "Nastavitve članstva",
  "请选择默认头像": "Izberite privzeti avatar",
  "门店二维码": "QR koda trgovine",
  "下载": "Prenesi",
  "营业时间": "Delovni čas",
  "店内营业时间": "Delovni čas v trgovini",
  "请选择店内营业时间": "Prosim izberite delovni čas v trgovini",
  "开始时间": "Začetni čas",
  "结束时间": "Končni čas",
  "至": "Do",
  "选择时间范围": "Izberite časovni razpon",
  "自提营业时间": "Čas samoprevzema",
  "请选择自提营业时间": "Izberite čas samoprevzema",
  "外卖营业时间": "Čas dostave hrane",
  "请选择外卖营业时间": "Izberite čas dostave hrane",
  "外卖配送": "Dostava hrane",
  "注": "Opomba",
  "外卖配送方式至少选择一个": "Izberite vsaj en način dostave hrane",
  "店内配置": "Konfiguracija trgovine",
  "店内用餐方式至少选择一个": "Izberite vsaj en način prehranjevanja v trgovini",
  "堂食服务": "Storitev jedilnice",
  "店内堂食结算模式": "Način plačila v jedilnici",
  "先结账后用餐": "Najprej plačajte, nato jedite",
  "先用餐后结账": "Najprej jedite, nato plačajte",
  "收银台桌台清台设置": "Nastavitve blagajne in čiščenje mize",
  "定时清台": "Časovno čiščenje mize",
  "立即清台": "Takojšnje čiščenje mize",
  "开启定时清台后，系统将在设置的时间后自动清除收银台点餐的桌台，此功能仅在餐前付款模式下生效": "Po vklopu časovnega čiščenja mize bo sistem samodejno očistil mizo s plačano blagajno po nastavljenem času. Ta funkcija deluje le v načinu plačila pred obrokom",
  "桌台订单清台设置": "Nastavitve čiščenja mize za naročila",
  "分钟后自动清理桌台（扫桌码点餐和收银桌台点餐定时清台时间）": "Samodejno očistite mizo po minutah (časovna čiščenja mize za naročila s skeniranjem kode mize in časovno čiščenje mize blagajne)",
  "店内堂食服务费": "Storitev plačila v trgovini",
  "按就餐人数收取": "Plačilo glede na število gostov",
  "按每桌台收取": "Plačilo na mizo",
  "请输入服务费": "Prosim vnesite strošek storitve",
  "位": "Sedež",
  "桌": "Miza",
  "店内包装费类型": "Vrsta stroška pakiranja v trgovini",
  "按商品收费": "Plačilo po izdelku",
  "按单收费": "Plačilo na naročilo",
  "包装费": "Strošek pakiranja",
  "请输入包装费": "Prosim vnesite strošek pakiranja",
  "外卖服务": "Storitev dostave hrane",
  "外卖包装费类型": "Vrsta stroška pakiranja v dostavi hrane",
  "外卖配送范围": "Obseg dostave hrane",
  "请输入外卖配送范围": "Prosim vnesite obseg dostave hrane",
  "外卖配送费": "Strošek dostave hrane",
  "请输入外卖配送费": "Prosim vnesite strošek dostave hrane",
  "最低消费": "Minimalna poraba",
  "请输入最低消费": "Prosim vnesite minimalno porabo",
  "桌码管理": "Upravljanje tabelne kode",
  "添加类型": "Dodaj vrsto",
  "类型名称": "Ime vrste",
  "删除": "Izbriši",
  "桌位管理": "Upravljanje miz",
  "最少人数": "Najmanjše število oseb",
  "最多人数": "Največje število oseb",
  "取 消": "Prekliči",
  "确 定": "Potrdi",
  "请输入类型名称": "Prosim vnesite ime vrste",
  "排序不能为空": "Sortiranje ne sme biti prazno",
  "排序必须为数字": "Sortiranje mora biti številka",
  "添加成功": "Uspešno dodano",
  "修改类型": "Spremeni vrsto",
  "修改成功": "Uspešno spremenjeno",
  "添加区域": "Dodaj območje",
  "区域名称": "Ime območja",
  "修改区域": "Spremeni območje",
  "请输入区域名称": "Prosim vnesite ime območja",
  "分类名称": "Ime kategorije",
  "编号": "Številka",
  "选择区域": "Izberi območje",
  "请选择": "Prosim izberite",
  "选择类型": "Izberi vrsto",
  "查询": "Iskanje",
  "桌号id": "ID mize",
  "所属区域": "Pripadajoče območje",
  "桌位类型": "Vrsta mize",
  "桌位编码": "Koda mize",
  "人数区间": "Območje števila oseb",
  "人": "Oseb",
  "二维码": "QR koda",
  "桌位编号": "Številka mize",
  "请输入桌位编号": "Prosim vnesite številko mize",
  "请选择类型名称": "Prosim izberite ime vrste",
  "请选择所属区域": "Prosim izberite pripadajoče območje",
  "添加桌位": "Dodaj mizo",
  "关键词": "Ključna beseda",
  "添加收银员": "Dodaj blagajnika",
  "姓名": "Ime",
  "登录账号": "Prijava računa",
  "联系方式": "Kontaktna metoda",
  "收银员管理": "Upravljanje blagajnikov",
  "编辑": "Uredi",
  "手机号": "Mobilna številka",
  "请输入登录账号": "Prosim vnesite prijavni račun",
  "长度在6到16个字符": "Dolžina med 6 do 16 znakov",
  "两次输入密码不一致！": "Gesli se ne ujemata!",
  "禁用": "Onemogoči",
  "删除后不可恢复，确认删除该记录吗?": "Po izbrisu ni mogoče obnoviti, potrjujete izbris tega zapisa?",
  "提示": "Nasvet",
  "后厨人员管理": "Upravljanje osebja v kuhinji",
  "添加后厨人员": "Dodaj osebje v kuhinji",
  "添加后厨账号": "Dodaj kuhinjski račun",
  "普通分类": "Običajna klasifikacija",
  "添加分类": "Dodaj kategorijo",
  "图片": "Slika",
  "分类排序": "Sortiranje kategorije",
  "税率设置": "Nastavitev davčne stopnje",
  "添加税率": "Dodaj davčno stopnjo",
  "税率分类名称": "Ime kategorije davčne stopnje",
  "税率": "Davčna stopnja",
  "适用于菜品分类": "Uporabno za klasifikacijo jedi",
  "未找到相应数据": "Ustreznih podatkov ni mogoče najti",
  "请输入分类名称": "Prosim vnesite ime kategorije",
  "分类排序不能为空": "Sortiranje kategorije ne sme biti prazno",
  "分类排序必须为数字": "Sortiranje kategorije mora biti številka",
  "正在翻译，请稍后": "Prevajanje, počakajte trenutek",
  "多语言翻译": "Večjezično prevajanje",
  "修改分类": "Spremeni kategorijo",
  "翻译": "Prevod",
  "分类图片": "Slika kategorije",
  "外卖商品": "Dostava hrane",
  "店内商品": "Trgovinsko blago",
  "商品管理": "Upravljanje blaga",
  "分类管理": "Upravljanje kategorij",
  "上架中": "Na voljo",
  "下架": "Izpustiti",
  "商品名称": "Ime izdelka",
  "请输入商品名称": "Prosim vnesite ime izdelka",
  "添加产品": "Dodaj izdelek",
  "产品": "Produkt",
  "实际销量": "Dejanska prodaja",
  "库存": "Zaloga",
  "发布时间": "Čas objave",
  "销售价": "Prodajna cena",
  "下架中": "Izpuščen",
  "强制下架": "Prisilno umakniti",
  "重新上架": "Ponovno na polici",
  "上架": "Na polici",
  "确认要": "Potrditev za",
  "成功": "Uspeh",
  "删除成功": "Izbriši uspešno",
  "请先选择一个选项": "Prosim najprej izberite možnost",
  "正在完成翻译，请稍后操作": "Dokončanje prevajanja, prosim izvedite kasneje",
  "请检查表单的必填项是否全部填写": "Prosimo preverite ali so vsa obvezna polja v obrazcu izpolnjena",
  "补全成功": "Uspešno dopolnjeno",
  "主语言选择": "Izbira glavnega jezika",
  "请选择主语言": "Prosim izberite glavni jezik",
  "高级设置": "Napredne nastavitve",
  "取消": "Prekliči",
  "修改": "Uredi",
  "保存成功": "Uspešno shranjeno",
  "规格": "Specifikacija",
  "库存计算方式": "Metoda izračuna zaloge",
  "下单减库存": "Naročilo za zmanjšanje zaloge",
  "特色分类": "Posebna klasifikacija",
  "产品规格": "Specifikacija izdelka",
  "单规格": "Enojna specifikacija",
  "多规格": "Več specifikacij",
  "此商品正在参加活动，不能修改规格": "Ta izdelek sodeluje v akciji in ne morete spreminjati specifikacij",
  "基本信息": "Osnovne informacije",
  "AI魔法创建": "Ustvarjanje s čarobno AI",
  "通过人工智能技术，可以根据商品名称自动填写商品详细信息，如配料、卖点、口味等。": "S pomočjo tehnologije umetne inteligence lahko avtomatsko izpolnite podrobne informacije o izdelku glede na ime izdelka, kot so sestavine, prodajne točke, okus, itd.",
  "所属分类": "Pripadnost kategoriji",
  "请选择商品分类": "Prosim izberite kategorijo izdelka",
  "请填写商品详情": "Prosim izpolnite podrobnosti izdelka",
  "商品详情": "Podrobnosti izdelka",
  "换一换": "Spremeni",
  "产品价格": "Cena izdelka",
  "请填写产品价格": "Prosim izpolnite ceno izdelka",
  "请填写包装费": "Prosim izpolnite strošek pakiranja",
  "规格明细": "Podrobnosti specifikacije",
  "规格名称": "Ime specifikacije",
  "请输入内容": "Prosim vnesite vsebino",
  "价格": "Cena",
  "添加规格": "Dodaj specifikacijo",
  "商品图片": "Slika izdelka",
  "请上传商品图片": "Prosim naložite sliko izdelka",
  "从AI图库中选择": "Izberi iz AI galerije",
  "使用中文从AI图库搜索": "Uporabi kitajščino za iskanje v AI galeriji",
  "AI图库": "AI galerija",
  "确认使用": "Potrdi uporabo",
  "AI未识别到您的商品图片": "AI ni prepoznal slike vašega izdelka",
  "可在搜索框": "Na voljo v iskalnem polju",
  "更换菜品名称": "Spremeni ime jedi",
  "请输入菜品名称！": "Prosim vnesite ime jedi!",
  "请在主语言界面上进行操作": "Prosim izvedite operacijo na vmesniku glavnega jezika",
  "本商品正在参加活动，不能删除规格！": "Ta izdelek sodeluje v akciji in ne morete izbrisati specifikacij!",
  "不能再删除了": "Ni mogoče več izbrisati",
  "多语言": "Večjezično",
  "商品加料": "Dodatki za izdelke",
  "添加加料": "Dodaj dodatke",
  "加料名称": "Ime dodatka",
  "如:杯型": "Na primer: kozarček",
  "内容": "Vsebina",
  "积分设置": "Nastavitev točk",
  "是否开启积分赠送": "Ali želite omogočiti dajanje točk",
  "关闭": "Zapri",
  "其他设置": "Druge nastavitve",
  "商品状态": "Stanje izdelka",
  "选择商品状态": "Izberite stanje izdelka",
  "初始销量": "Začetna prodaja",
  "商品排序": "Razvrstitev izdelka",
  "限购数量": "Omejitev nakupa",
  "每个会员购买的最大数量，0为不限购": "Največje število, ki ga lahko član kupi, 0 pomeni brez omejitve",
  "会员折扣设置": "Nastavitev popusta za člane",
  "是否开启会员折扣": "Ali želite omogočiti popust za člane",
  "默认折扣": "Privzeti popust",
  "单独设置折扣": "Posebna nastavitev popusta",
  "默认折扣：默认为用户所属会员等级的折扣率": "Privzeti popust: Privzeto je stopnja popusta članskega nivoja, kamor spada uporabnik",
  "折扣佣金类型": "Vrsta popusta",
  "百分比": "Odstotek",
  "固定金额": "Fiksna vsota",
  "折扣": "Popust",
  "请输入折扣": "Vnesite popust",
  "分销设置": "Nastavitve distribucije",
  "是否开启分销": "Ali želite omogočiti distribucijo",
  "分销规则": "Pravila distribucije",
  "平台规则": "Pravila platforme",
  "单独规则": "Posebna pravila",
  "平台规则：层级": "Pravila platforme: Nivo",
  "1级佣金": "Provizija 1. nivoja",
  "2级佣金": "Provizija 2. nivoja",
  "3级佣金": "Provizija 3. nivoja",
  "分销佣金类型": "Vrsta provizije za distribucijo",
  "单独分销设置": "Posebne nastavitve distribucije",
  "一级佣金": "Provizija 1. nivoja",
  "二级佣金": "Provizija 2. nivoja",
  "三级佣金": "Provizija 3. nivoja",
  "请填写商品名称": "Prosim vnesite ime izdelka",
  "你选择商品分类": "Izbrali ste kategorijo izdelka",
  "商品卖点": "Prodajna točka izdelka",
  "配料": "Sestavine",
  "添加项": "Dodaj postavko",
  "删除项": "Izbriši postavko",
  "审核状态": "Status pregleda",
  "选择审核状态": "Izberite status pregleda",
  "通过": "Odobreno",
  "未通过": "Ni odobreno",
  "审核备注": "Opomba pregleda",
  "请输入拒绝原因": "Prosim vnesite razlog za zavrnitev",
  "商品属性": "Atributi izdelka",
  "添加属性": "Dodaj lastnosti",
  "属性名称": "Ime lastnosti",
  "属性值": "Vrednost lastnosti",
  "至少填写两个": "Najmanj dve polji izpolnite",
  "如:温度": "Na primer: temperatura",
  "口味": "Okus",
  "商品同步": "Sinhronizacija izdelka",
  "同步至外卖": "Sinhroniziraj za dostavo",
  "库存数量": "Količina na zalogi",
  "请填写库存数量": "Prosim vnesite količino na zalogi",
  "请上传分类图片": "Prosim naložite sliko kategorije",
  "发布": "Objavi",
  "级": "Nivo",
  "请填写口味": "Prosim vnesite okus",
  "从AI图库搜索": "Išči v AI galeriji",
  "AI获取标签": "AI pridobi oznako",
  "标签": "Oznaka",
  "添加的标签可以帮助AI点餐助手更准确地理解顾客的点餐需求": "Dodane oznake lahko pomagajo AI pomočniku za naročila, da bolje razume potrebe strank pri naročilih",
  "同步至店内": "Sinhroniziraj za notranjo uporabo",
  "是否同步商品至外卖": "Ali želite sinhronizirati izdelke za dostavo",
  "是否同步商品至店内": "Ali želite sinhronizirati izdelke za interno uporabo",
  "付款减库存": "Plačilo za zmanjšanje zaloge",
  "菜品录入使用语言": "Jezik vnosa jedi",
  "网站主页": "Spletna domača stran",
  "主题编辑": "Urejanje teme",
  "我的菜单": "Moje meni",
  "添加菜单": "Dodaj meni",
  "菜单名称": "Ime menija",
  "图标": "Ikona",
  "是否显示": "Ali želite prikazati",
  "添加时间": "Čas dodajanja",
  "更新时间": "Čas posodabljanja",
  "操作": "Operacija",
  "正在处理": "V obdelavi",
  "处理失败，请重试": "Napaka pri obdelavi, poskusite znova",
  "此操作将永久删除该记录, 是否继续?": "Ta operacija bo trajno izbrisala ta zapis. Ali želite nadaljevati?",
  "确定": "Potrdi",
  "主题选择": "Izbira teme",
  "主题一": "Tema ena",
  "主题二": "Tema dva",
  "主题三": "Tema tri",
  "主题四": "Tema štiri",
  "主题五": "Tema pet",
  "主题六": "Tema šest",
  "主页预览": "Predogled domače strani",
  "撤回": "Prekliči",
  "获取预览网站失败,请检查网络或联系管理员": "Napaka pri pridobivanju predogleda spletne strani, preverite omrežje ali stopite v stik s skrbnikom",
  "撤回成功": "Preklic uspešen",
  "编辑菜单": "Uredi meni",
  "请输入广告标题": "Prosim vnesite naslov oglasa",
  "图标大小为": "Velikost ikone je",
  "显示": "Prikaži",
  "隐藏": "Skrij",
  "请输入数字": "Prosim vnesite številko",
  "链接": "Povezava",
  "选择链接": "Izberi povezavo",
  "提交": "Predloži",
  "请输入菜单名称": "Prosim vnesite ime menija",
  "链接到": "Povezava do",
  "请上传图标": "Prosim naložite ikono",
  "确定要删除吗?": "Ali ste prepričani, da želite izbrisati?",
  "次浏览": "Število ogledov",
  "每日必拼": "Dnevni nujni izdelek",
  "更多": "Več",
  "2人团": "2-članska skupina",
  "去开团": "Sodelujte v skupini",
  "活动砍价": "Događanje za ceno",
  "已抢2件": "Že ukradeni 2 kosi",
  "立即砍价": "Zmanjšajte ceno zdaj",
  "满": "Popolno",
  "可用": "Na voljo",
  "立即领取": "Prevzemite zdaj",
  "热门直播": "Priljubljeno v živo",
  "已售": "Prodano",
  "限时秒杀": "Omejen čas za ubijanje",
  "搜索商品": "Iskanje izdelkov",
  "线下门店": "Trgovina na terenu",
  "门店logo": "Logotip trgovine",
  "门店地址": "Naslov trgovine",
  "联系电话": "Kontaktna številka",
  "您的浏览器不支持 video 标签": "Vaš brskalnik ne podpira oznak video",
  "店家正在直播、折扣套餐秒杀中": "Trgovina v živo, znižani paketi in sekunde",
  "进入": "Vstopi",
  "至少保留一个": "Obdržite vsaj enega",
  "咨询分类": "Kategorija posvetovanja",
  "全部分类": "Vse kategorije",
  "显示数量": "Prikaži količino",
  "咨询数据请到": "Za posvetovanje podatkov se obrnite na",
  "中管理": "Srednji meni",
  "插件": "Vstavek",
  "资讯": "Informacije",
  "显示类型": "Prikaži tip",
  "有图模式": "Način z slike",
  "无图模式": "Način brez slike",
  "组件样式": "Slog komponente",
  "显示内容": "Prikaži vsebino",
  "拼团价格": "Cena skupinskih",
  "划线价格": "Prečrtana cena",
  "指示点颜色": "Barva kazalnih točk",
  "重置": "Ponastavi",
  "切换时间": "Preklopi čas",
  "轮播图自动切换的间隔时间，单位：毫秒": "Časovni interval za avtomatsko preklapljanje slike v predvajanju, enota: milisekunde",
  "链接地址": "Povezava",
  "请选择链接地址": "Izberite povezavo",
  "添加一个": "Dodaj eno",
  "标题内容": "Vsebina naslova",
  "文字内容": "Besedilna vsebina",
  "链接名称": "Ime povezave",
  "正在砍价": "Pogajanje",
  "商品原价": "Originalna cena izdelka",
  "背景颜色": "Barva ozadja",
  "组件高度": "Višina komponente",
  "上下边距": "Zgornji in spodnji rob",
  "线条样式": "Slog linije",
  "实线": "Polna črta",
  "虚线": "Črtkana črta",
  "点状": "Pikčasta",
  "线条颜色": "Barva linije",
  "线条高度": "Višina linije",
  "左右边距": "Levi in desni rob",
  "标题": "Naslov",
  "颜色": "Barva",
  "每行数量": "Število na vrsto",
  "1个": "1 kos",
  "2个": "2 kosa",
  "文字颜色": "Barva besedila",
  "公告图标": "Ikona obvestila",
  "公告内容": "Vsebina obvestila",
  "商品来源": "Izvor izdelka",
  "自动获取": "Samodejno pridobi",
  "手动选择": "Ročna izbira",
  "综合": "Celovito",
  "商品列表": "Seznam izdelkov",
  "选择产品": "Izberi izdelek",
  "列表平铺": "Razporeditev seznama",
  "横向滑动": "Drsnik vodoravno",
  "分列数量": "Število stolpcev",
  "单列": "En stolpec",
  "两列": "Dva stolpca",
  "三列": "Trije stolpci",
  "商品价格": "Cena izdelka",
  "商品销量": "Prodaja izdelka",
  "提示文字": "Besedilo opozorila",
  "搜索框样式": "Slog iskalnega okvirja",
  "方形": "Kvadratni",
  "圆角": "Zakrožen rob",
  "圆弧": "Lok",
  "文字对齐": "Poravnava besedila",
  "居左": "Na levo",
  "居中": "Na sredino",
  "居右": "Na desno",
  "秒杀价格": "Cena sekundnega ubijanja",
  "底边距": "Spodnji rob",
  "右边距": "Desni rob",
  "不透明度": "Neprozornost",
  "客服类型": "Vrsta službe za stranke",
  "在线聊天": "Spletni klepet",
  "拨打电话": "Pokliči",
  "电话号码": "Telefonska številka",
  "客服图标": "Ikona službe za stranke",
  "标题类型": "Vrsta naslova",
  "页面名称": "Ime strani",
  "页面名称仅用于后台查找": "Ime strani se uporablja samo za iskanje v ozadju",
  "分享标题": "Naslov za deljenje",
  "小程序端转发时显示的标题": "Naslov, prikazan ob deljenju mini programa",
  "文章数据请到": "Za podatke o člankih prosimo pojdite na",
  "内容管理": "Upravljanje vsebin",
  "文章列表": "Seznam člankov",
  "单行": "Ena vrstica",
  "两行": "Dve vrstici",
  "门店列表": "Seznam trgovin",
  "选择门店": "Izberi trgovino",
  "展示数量": "Prikaži količino",
  "视频高度": "Višina videa",
  "滑块可用左右方向键精确调整": "Drsnik je mogoče natančno prilagajati s tipkami za levo in desno",
  "视频封面": "Naslovnica videa",
  "视频地址": "Naslov videa",
  "自动播放": "Samodejno predvajanje",
  "布局方式": "Način postavitve",
  "堆积两列": "Skladišči dva stolpca",
  "堆积三列": "Skladišči tri stolpce",
  "堆积四列": "Skladišči štiri stolpce",
  "橱窗样式": "Slog vitrine",
  "橱窗样式最多显示四张图片，超出隐藏": "Slog vitrine prikazuje največ štiri slike, preostale so skrite",
  "请确保所有图片的尺寸/比例相同": "Prosimo, poskrbite, da imajo vse slike enako velikost/razmerje",
  "标题文字": "Besedilo naslova",
  "组件库": "Knjižnica komponent",
  "媒体组件": "Medijska komponenta",
  "商城组件": "Komponenta nakupovalnega središča",
  "工具组件": "Komponenta orodja",
  "登录组件": "Komponenta prijave",
  "资讯管理": "Upravljanje informacij",
  "添加资讯": "Dodaj informacije",
  "资讯ID": "ID informacije",
  "封面": "Naslovnica",
  "资讯标题": "Naslov informacije",
  "虚拟阅读量": "Virtualno branje",
  "实际阅读量": "Dejansko branje",
  "资讯排序": "Vrsta informacij",
  "已取消删除": "Brisanje preklicano",
  "请输入文章标题": "Prosim vnesite naslov članka",
  "描述": "Opis",
  "请输入文章描述": "Prosim vnesite opis članka",
  "缩略图": "Sličica",
  "资讯分类": "Kategorija informacij",
  "资讯状态": "Stanje informacij",
  "资讯内容": "Vsebina informacij",
  "分类ID": "ID kategorije",
  "编辑分类": "Uredi kategorijo",
  "恭喜你，修改成功": "Čestitke, uspešna sprememba",
  "编辑资讯": "Uredi informacije",
  "份": "Obrok",
  "中文": "Kitajščina",
  "英语": "Angleščina",
  "意大利语": "Italijanščina",
  "德语": "Nemščina",
  "西班牙语": "Španščina",
  "法语": "Francoščina",
  "克罗地亚": "Hrvaška",
  "斯洛文尼亚": "Slovenščina",
  "匈牙利语": "Madžarščina",
  "规格库": "Knjižnica specifikacij",
  "属性库": "Knjižnica atributov",
  "加料库": "Knjižnica dodatkov",
  "规格名": "Ime specifikacije",
  "批量删除": "Združeno brisanje",
  "请输入规格名称": "Prosim vnesite ime specifikacije",
  "删除后不可恢复，确认删除吗?": "Po brisanju ni mogoče obnoviti, potrdite brisanje?",
  "属性名": "Ime atributa",
  "请输入属性名称": "Prosim vnesite ime atributa",
  "请输入属性值": "Prosim vnesite vrednost atributa",
  "添加属性名": "Dodaj ime atributa",
  // =========== 建店必做 end ==================

  // ================ 订单 start ================
  "实时概况": "Prezrtti pregled",
  "营业总额": "Skupni poslovni prihodki",
  "有效订单": "Veljavna naročila",
  "退款金额": "Znesek vračila",
  "销量排行榜": "Seznam prodaje",
  "销售额排行榜": "Seznam prodaje po znesku",
  "订单号": "Številka naročila",
  "请输入订单号": "Prosimo vnesite številko naročila",
  "配送方式": "Način dostave",
  "起始时间": "Začetni čas",
  "开始日期": "Začetni datum",
  "结束日期": "Končni datum",
  "导出": "Izvozi",
  "全部订单": "Vsa naročila",
  "未付款": "Neplačano",
  "进行中": "V teku",
  "已完成": "Dokončano",
  "订单信息": "Informacije o naročilu",
  "下单时间": "Čas naročila",
  "取消申请中": "V teku je prošnja za preklic",
  "实付款": "Dejansko plačilo",
  "含服务费": "Vključno s stroški storitev",
  "含包装费": "Vključno s stroški pakiranja",
  "买家": "Kupec",
  "出餐状态": "Status obroka",
  "准备中": "Priprava",
  "出餐中": "Priprava obroka",
  "待取餐": "Čakanje na prevzem",
  "交易状态": "Stanje transakcije",
  "支付方式": "Način plačila",
  "订单详情": "Podrobnosti naročila",
  "出餐": "Postrezi obrok",
  "退款": "Vračilo",
  "核销": "Preveri",
  "确定要出餐吗?": "Ste prepričani, da želite postreči obrok?",
  "确定要核销吗?": "Ste prepričani, da želite preveriti?",
  "恭喜你，操作成功": "Čestitke, operacija uspešna",
  "已取消核销": "Preverjanje preklicano",
  "订单来源": "Vir naročila",
  "订单金额": "Znesek naročila",
  "配送费": "Stroški dostave",
  "服务费": "Stroški storitve",
  "优惠券抵扣": "Popust s kuponm",
  "积分抵扣": "Popust s točkami",
  "满减金额": "Znesek popusta za polnjenje",
  "优惠金额": "Znesek popusta",
  "实付款金额": "Dejanski znesek plačila",
  "用餐方式": "Način obroka",
  "取餐时间": "Čas prevzema",
  "桌号": "Številka mize",
  "修改价格": "Spremeni ceno",
  "门店信息": "Informacije o trgovini",
  "商品信息": "Informacije o izdelku",
  "会员折扣价": "Članski popust",
  "购买数量": "Količina nakupa",
  "商品总价": "Skupna cena izdelkov",
  "收货信息": "Informacije o prevzemu",
  "收货人": "Prejemnik",
  "收货电话": "Telefon prejemnika",
  "收货地址": "Naslov prejema",
  "备注": "Opomba",
  "自提用户信息": "Informacije o samoprevzemu uporabnika",
  "用户信息": "Informacije o uporabniku",
  "联系手机": "Kontaktni mobilni telefon",
  "付款信息": "Informacije o plačilu",
  "应付款金额": "Znesek za plačilo",
  "支付流水号": "Številka plačila",
  "付款状态": "Stanje plačila",
  "付款时间": "Čas plačila",
  "发货信息": "Informacije o pošiljanju",
  "发货状态": "Stanje pošiljanja",
  "取消信息": "Informacije o preklicu",
  "商家备注": "Opomba trgovca",
  "门店自提核销": "Samoprevzem trgovine",
  "核销员": "Cerkveni zapisovalec",
  "核销状态": "Stanje preverjanja",
  "已核销": "Preverjeno",
  "核销时间": "Čas preverjanja",
  "返回上一页": "Vrni se na prejšnjo stran",
  "确认发货": "Potrdi pošiljanje",
  "确认审核": "Potrdi pregled",
  "请选择物流公司": "Prosimo izberite logistično podjetje",
  "请填写物流单号": "Prosimo vnesite številko pošiljke",
  "恭喜你，发货成功": "Čestitke, pošiljanje uspešno",
  "恭喜你，审核成功": "Čestitke, pregled uspešen",
  "订单价格修改": "Sprememba cene naročila",
  "运费金额": "Znesek prevoza",
  "最终付款价": "Končna cena plačila",
  "取消订单": "Prekliči naročilo",
  "请输入备注": "Prosimo vnesite opombo",
  "请输入退款金额": "Prosimo vnesite znesek vračila",
  "确认退款?": "Potrdi vračilo?",
  "已取消退款": "Vračilo preklicano",
  "含配送费": "Vključno s stroški dostave",
  "确认送达": "Potrdi dostavo",
  "是否确认此操作?": "Ali potrdite to dejanje?",
  "配送状态": "Stanje dostave",
  "备注信息": "Informacije o opombi",
  "期望配送时间": "Pričakovani čas dostave",
  "订单状态": "Stanje naročila",
  "骑手姓名": "Ime kolesarja",
  "骑手电话": "Kolesarjev telefon",
  "操作时间": "Čas operacije",
  "详情": "Podrobnosti",
  "此操作将确认送达, 是否继续?": "To dejanje bo potrdilo dostavo, želite nadaljevati?",
  "配送时间": "Čas dostave",
  "配送信息": "Podatki o dostavi",
  "配送类型": "Vrsta dostave",
  "配送距离": "Razdalja dostave",
  "配送电话": "Telefon dostave",
  "配送费用": "Stroški dostave",
  "送达时间": "Čas prihoda",
  "取消原因": "Razlog za preklic",
  "请输入取消原因": "Prosimo vnesite razlog preklica",
  "米": "Meter",
  // ================ 订单 end  ================

  // ================= 门店 start ==============
  "门店ID": "ID trgovine",
  "联系地址": "Kontaktni naslov",
  "下载二维码": "Prenos QR kode",
  "H5网页": "H5 spletna stran",
  "添加门店": "Vključitev ustanovitve",
  "设置": "Konfiguracija",
  "恭喜你，门店删除成功": "Čestitke, uspešno brisanje trgovine",
  "请输入地点": "Prosim vnesite lokacijo",
  "添加": "Vključitev",
  "等级": "Razred",
  "请选择会员等级": "Prosim izberite članstvo razreda",
  "性别": "Spol",
  "请选择性别": "Prosim izberite spol",
  "微信昵称": "WeChat vzdevek",
  "请输入微信昵称": "Prosim vnesite WeChat vzdevek",
  "微信头像": "WeChat profilna slika",
  "昵称": "Vzdevek",
  "用户余额": "Stanje uporabnika",
  "累积消费金额": "Kumulativni znesek porabe",
  "注册时间": "Čas registracije",
  "分钟后自动清理桌台": "Samodejno čiščenje miz po minutah",
  "扫桌码点餐和收银桌台点餐定时清台时间": "Časovni razpored čiščenja miz za naročanje s skeniranjem miz za naročanje in blagajniških miz",
  "到店自提": "Prevzem v trgovini",
  "打包带走": "S seboj",
  "店内就餐": "Za jesti v trgovini",
  "外卖配送至少选择一种！": "Izberite vsaj en način dostave za prevzem!",
  "店内配置至少选择一种！": "Izberite vsaj eno trgovinsko konfiguracijo!",
  "恭喜你，设置成功": "Čestitke, uspešna konfiguracija",
  "恭喜你，门店修改成功": "Čestitke, uspešna sprememba trgovine",
  "门店": "Trgovina",
  "提现金额": "Znesek dviga",
  "打款方式": "Način plačila",
  "待审核": "Čakanje na pregled",
  "审核通过": "Odobreno",
  "驳回": "Zavrnjeno",
  "原因": "Razlog",
  "已打款": "Plačilo opravljeno",
  "审核": "Pregled",
  "确认打款": "Potrdi plačilo",
  "确认要打款吗?": "Potrdi plačilo?",
  "供应商名称": "Ime dobavitelja",
  "余额变动场景": "Scena spremembe stanja",
  "收入": "Prihodek",
  "提现": "Dvig",
  "起始日期": "Začetni datum",
  "变动金额": "Spremenjen znesek",
  "描述/说明": "Opis/Pojasnilo",
  "创建时间": "Čas ustvarjanja",
  "恭喜你，门店添加成功": "Čestitke, uspešno dodajanje trgovine",
  "驳回原因": "Razlog za zavrnitev",
  "提现审核": "Pregled dviga",
  "小票打印设置": "Nastavitev tiskanja računa",
  "是否开启商户小票打印": "Omogoči tiskanje računa za trgovce",
  "选择打印机": "Izberite tiskalnik",
  "是否开启顾客小票打印": "Omogoči tiskanje računa za stranke",
  "选择打印机二": "Izberite tiskalnik dva",
  "是否开启厨房小票打印": "Omogoči tiskanje kuhinjskih računov",
  "选择打印机三": "Izberite tiskalnik tri",
  "恭喜你，打印设置成功": "Čestitke, uspešna nastavitev tiskanja",
  "小票打印机列表": "Seznam tiskalnikov računov",
  "打印机ID": "ID tiskalnika",
  "打印机名称": "Ime tiskalnika",
  "编辑小票打印机": "Urejanje tiskalnika računov",
  "打印机类型": "Vrsta tiskalnika",
  "米泰打印机": "Tiskalnik Mettai",
  "打印机编号": "Številka tiskalnika",
  "打印机编号为9位数字，查看米泰打印机底部贴纸上面的编号": "Številka tiskalnika sestoji iz 9 številk, preverite številko na nalepki na dnu tiskalnika Mettai",
  "打印机秘钥": "Ključ tiskalnika",
  "打印联数": "Število natisov",
  "同一订单，打印的次数": "Število natisov za isto naročilo",
  "排序": "Vrstni red",
  "数字越小越靠前": "Manjše število pomeni višjo prioriteto",
  "新增小票打印机": "Dodaj nov tiskalnik računov",
  "恭喜你，添加成功": "Čestitke, uspešno dodajanje",
  "配送方式设置": "Nastavitev načina dostave",
  "商家配送": "Dostava trgovca",
  "自动配送时间(分钟)": "Samodejni čas dostave (v minutah)",
  "设置0不自动配送，下单后未配送，设置时间后自动操作配送": "Nastavitev na 0 pomeni nobene samodejne dostave. Po naročilu brez dostave se bo samodejno opravila dostava po nastavljenem času",
  "商户编号": "ID trgovca",
  "门店编号": "ID trgovine",
  "环境": "Okolje",
  "测试环境": "Testno okolje",
  "正式环境": "Produkcijsko okolje",
  "回调地址": "Klicni naslov",
  "运营城市": "Operativno mesto",
  "恭喜你，上传设置成功": "Čestitke, uspešna nastavitev prenosa",
  "菜品打印列表": "Seznam tiskanja hrane",
  "名称": "Ime",
  "打印类型": "Vrsta tiskanja",
  "外卖": "Dame-Ut",
  "店内": "V trgovini",
  "菜品打印": "Tiskanje hrane",
  "是否开启": "Omogoči",
  "配送打印": "Tiskanje dostave",
  "店内打印": "Tiskanje v trgovini",
  "打印方式": "Način tiskanja",
  "付款打印": "Tiskanje plačila",
  "下单打印": "Naročilo tiskanja",
  "商品分组": "Razvrstitev izdelkov",
  "男": "Moški",
  "女": "Ženska",
  "未知": "Neznano",
  "文件管理": "Upravljanje datotek",
  "移动至": "Premakni v",
  "点击上传": "Kliknite za nalaganje",
  "删除失败": "Brisanje ni uspelo",
  "请选择文件": "Prosim izberite datoteko",
  "确定移动选中的文件吗？, 是否继续?": "Ste prepričani, da želite premakniti izbrane datoteke? Želite nadaljevati?",
  "只能上传图片！": "Lahko naložite samo slike!",
  "上传文件只能是图片格式!": "Naložena datoteka mora biti v obliki slike!",
  "上传文件大小不能超过 2MB!": "Velikost naložene datoteke ne sme presegati 2 MB!",
  "请查看/裁切其它上传图片!": "Prosim preglejte/obrežite druge naložene slike!",
  "图片上传中,请等待": "Nalaganje slike, počakajte",
  "当前图片上传失败!": "Napaka pri trenutnem nalaganju slike!",
  "本次上传图片失败": "Napaka pri nalaganju slike tokrat",
  "本次最多只能上传1个文件": "Tokrat lahko naložite največ 1 datoteko",
  "裁剪图片": "Obreži sliko",
  "选择优惠券": "Izberite kupon",
  "数量": "Količina",
  "无限制": "Neomejeno",
  "请输入等级名称": "Prosim vnesite ime razreda",
  "长度在3到5个字符": "Dolžina naj bo med 3 in 5 znakov",
  "错了哦，这是一条错误消息": "Opa, to je sporočilo o napaki",
  "增加税率": "Dodaj davek",
  "税率分类": "Davčna stopnja kategorije",
  "请输入税率分类": "Vnesite kategorijo davčne stopnje",
  "自定义税率分类": "Prilagojena davčna stopnja kategorije",
  "请输入税率值": "Vnesite vrednost davčne stopnje",
  "单位是": "Enota je",
  "适用菜品分类": "Velja za kategorijo jedi",
  "请选择菜品分类": "Prosim izberite kategorijo jedi",
  "修改税率信息": "Spremeni informacije o davčni stopnji",
  "分类名称不能为空": "Ime kategorije ne sme biti prazno",
  // ================= 门店 end ==============
  // =====================  营销工具start ==========

  "会员管理": "Upravljanje članstva",
  "等级管理": "Upravljanje ravni",
  "余额明细": "Podrobnosti stanja",
  "请输入昵称": "Prosim vnesite vzdevek",
  "邮箱": "E-pošta",
  "请输入邮箱地址": "Prosim vnesite e-poštni naslov",
  "会员等级": "Članska stopnja",
  "全部": "Vse",
  "无等级": "Brez stopnje",
  "余额": "Stanje",
  "积分": "Točke",
  "生日": "Rojsni dan",
  "充值": "Polnitev",
  "恭喜你，用户删除成功": "Čestitke, uporabnik uspešno izbrisan",
  "请选择等级": "Prosim izberite stopnjo",
  "管理员备注": "Opombe administratorja",
  "请输入管理员备注": "Prosim vnesite opombe administratorja",
  "恭喜你，用户修改成功": "Čestitke, uporabnik uspešno spremenjen",
  "会员充值": "Polnitev članstva",
  "充值余额": "Znesek polnitve",
  "当前余额": "Trenutno stanje",
  "充值方式": "Način polnitve",
  "增加": "Povečaj",
  "减少": "Zmanjšaj",
  "最终金额": "Končni znesek",
  "变更金额": "Spremenjen znesek",
  "请输入变更金额": "Prosim vnesite spremenjen znesek",
  "添加等级": "Dodaj stopnjo",
  "等级名称": "Ime stopnje",
  "权重": "Utež",
  "升级条件": "Pogoji za nadgradnjo",
  "等级权重": "Utež stopnje",
  "请输入等级权重": "Prosim vnesite utež stopnje",
  "权重越大，等级越高": "Večja ko je utež, višja je stopnja",
  "等级折扣": "Popust stopnje",
  "请输入等级折扣": "Prosim vnesite popust stopnje",
  "满足以下勾选的其中一个条件，会员自动升级到该等级": "Zadovoljite enega izmed označenih pogojev spodaj, član se bo samodejno nadgradil na to stopnjo",
  "累计消费满": "Kumulativna poraba doseže",
  "编辑等级": "Uredi stopnjo",
  "累计积分满": "Kumulativne točke dosežejo",
  "推荐人数满": "Število priporočil doseže",
  "恭喜你，等级修改成功": "Čestitke, stopnja uspešno spremenjena",
  "个": "kosov",
  "充值设置": "Nastavitve polnitve",
  "是否开启余额充值": "Omogoči polnitev stanja",
  "注：如开启则移动端显示充值按钮，如果小程序没有资质审核不过可不开启": "Opomba: Če je omogočeno, bo na mobilni napravi prikazan gumb za polnitev; če mini program ne uspe pregled kvalifikacij, lahko ostane onemogočen",
  "是否开启自定义金额": "Omogoči prilagojen znesek",
  "注：如开启则用户可以填写充值金额": "Opomba: Če je omogočeno, lahko uporabniki vpišejo prilagojen znesek polnitve",
  "最低充值金额": "Najnižji znesek polnitve",
  "注：自定义充值金额最低充值多少€": "Opomba: Koliko je najnižji znesek prilagojene polnitve?",
  "充值说明": "Navodila za polnitev",
  "充值套餐": "Paketi polnitve",
  "支付金额": "Znesek plačila",
  "到账数量": "Prejeti znesek",
  "充值时间": "Čas polnitve",
  "到账金额": "Prejeti znesek",
  "赠送金额": "Darilo",
  "提现设置": "Nastavitve dviga",
  "是否开启提现": "Omogoči dvige",
  "注：如开启则移动端显示余额提现": "Opomba: Če je omogočeno, bo na mobilni napravi prikazana možnost dviga stanja",
  "提现比例": "Odstotek dviga",
  "注：提现比例请填写数字0~100": "Opomba: Prosimo vnesite odstotek dviga med 0 in 100",
  "例：提现金额(100.00元) * 提现比例(100%) = 实际到账(100€)": "Primer: Znesek dviga (100,00 evrov) * Odstotek dviga (100%) = Dejanski prejeti znesek (100€)",
  "最低提现金额": "Najnižji znesek dviga",
  "注：最低提现金额多少元": "Opomba: Koliko je najmanjši znesek dviga v juanih?",
  "请选择状态": "Prosim izberite stanje",
  "提现方式": "Način dviga",
  "请选择提现方式": "Prosim izberite način dviga",
  "微信": "WeChat",
  "支付宝": "Alipay",
  "银行卡": "Bančna kartica",
  "请输入用户ID": "Prosim vnesite uporabniški ID",
  "请输入昵称/姓名/手机号": "Prosim vnesite vzdevek/ime/telefonsko številko",
  "提现信息": "Informacije o dvigu",
  "支付宝名称": "Ime Alipay",
  "支付宝账号": "Račun Alipay",
  "银行名称": "Ime banke",
  "开户名": "Ime lastnika računa",
  "银行卡号": "Številka bančne kartice",
  "申请时间": "Čas vloge",
  "审核时间": "Čas pregleda",
  "微信付款": "WeChat plačilo",
  "该操作 将使用微信支付企业付款到零钱功能，确定打款吗？": "Ta operacija bo uporabila funkcijo podjetniškega plačila WeChat za prenos na denarnico. Ste prepričani, da želite nadaljevati?",
  "添加充值套餐": "Dodaj paket polnitve",
  "套餐名称": "Ime paketa",
  "请输入套餐名称": "Prosim vnesite ime paketa",
  "请输入支付金额": "Prosim vnesite znesek plačila",
  "请输入赠送金额": "Prosim vnesite znesek darila",
  "请输入到账金额": "Prosim vnesite prejeti znesek",
  "请输入排序": "Prosim vnesite vrstni red",
  "用户ID": "Uporabniška identifikacija",
  "会员卡管理": "Upravljanje članskih kartic",
  "领取记录": "Zapisi o prejemu",
  "删除记录": "Izbriši zapis",
  "请输入关键词": "Prosim vnesite ključno besedo",
  "过期": "Poteklo",
  "有效": "Veljavno",
  "客户信息": "Podatki o stranki",
  "会员卡名称": "Ime članske kartice",
  "有效期": "Veljavnost",
  "折": "Popust",
  "领取时间": "Čas prejema",
  "延期": "Podaljšaj",
  "撤销": "Prekliči",
  "添加会员卡": "Dodaj člansko kartico",
  "启用": "Omogoči",
  "月": "Mesec",
  "永久有效": "Večno veljavno",
  "领取数量": "Število prejemnikov",
  "发卡": "Izdaja kartice",
  "领取设置": "Nastavitve prejema",
  "请检查必填项是否填写完整": "Prosim preverite, ali so obvezna polja pravilno izpolnjena",
  "领取人数": "Število prejemnikov",
  "删除时间": "Čas brisanja",
  "请填写有效期": "Prosim vnesite veljavnost",
  "有效期限（月），0为永久有效": "Veljavnost (v mesecih), 0 za večno veljavnost",
  "请填写价格": "Prosim vnesite ceno",
  "用户购买会员卡需要支付的金额，0为用户免费领取": "Znesek, ki ga morajo uporabniki plačati za nakup članske kartice, 0 za brezplačno izdajo",
  "使用须知": "Navodila za uporabo",
  "请填写使用须知": "Prosim vnesite navodila za uporabo",
  "请填写会员卡名称": "Prosim vnesite ime članske kartice",
  "卡片类型": "Vrsta kartice",
  "卡片样式": "Slog kartice",
  "请填写排序": "Prosim vnesite vrstni red",
  "会员权益": "Ugodnosti članov",
  "无折扣": "Brez popusta",
  "请填写折扣": "Prosim vnesite popust",
  "开卡赠送": "Darilo ob izdaji kartice",
  "优惠券": "Kupon",
  "请填写积分数量": "Prosim vnesite količino točk",
  "请填写余额数量": "Prosim vnesite znesek stanja",
  "请填写优惠券": "Prosim vnesite kupon",
  "添加优惠券": "Dodaj kupon",
  "券名称": "Ime kupona",
  "每人领取数量": "Količina na osebo",
  "选择优惠券弹出层": "Izberi pojavno okno za kupon",
  "您已经选择了十五张优惠券，若要更换请删除其他优惠券！": "Izbrali ste že petnajst kuponov, če želite zamenjati, izbrišite druge!",
  "产品编码": "Šifra izdelka",
  "请填写产品编码": "Prosimo izpolnite kodo izdelka",
  "产品划线价": "Cenik izdelka",
  "请填写产品划线价": "Prosim, navedite cenik izdelka",
  "商品重量": "Teža izdelka",
  "请填写商品重量": "Prosim, navedite težo izdelka",
  "批量设置": "Nastavitve na debelo",
  "划线价": "Cenik",
  "重量": "Teža",
  "应用": "Uporabi",
  "规格图片": "Slikovne specifikacije",
  "规格值": "Vrednost specifikacije",
  "请输入规格值": "Prosim, vnesite vrednost specifikacije",
  "请填写规则名或规则值": "Prosim, vnesite ime pravila ali vrednost pravila",
  "规格值不能为空": "Vrednost specifikacije ne sme biti prazna",
  "卡名称": "Ime kartice",
  "卡ID": "ID kartice",
  "无": "Brez",
  "选择会员": "Izberi člana",
  "恭喜你，发卡成功": "Čestitke, izdaja kartice uspešna",
  "副卡数": "Število dodatnih kartic",
  "张": "kosov",
  "选择日期": "Izberi datum",
  "签到设置": "Nastavitve prijave",
  "签到记录": "Zgodovina prijav",
  "是否开启签到有礼": "Ali želite omogočiti nagrade za prijavo",
  "每日签到固定奖励": "Fiksna nagrada za dnevne prijave",
  "每日签到送": "Nagrada za dnevne prijave",
  "递增奖励": "Povečana nagrada",
  "有": "Da",
  "第二天起递增奖励": "Povečana nagrada od drugega dneva naprej",
  "请输入第二天起递增积分数": "Prosim, vnesite naraščajoče točke od drugega dneva naprej",
  "第": "Dan",
  "请输入第几天不再递增": "Vnesi dan, ko se povečanje konča",
  "天起不再递增": "Od tega dneva dalje ni več povečanja",
  "连续签到额外奖励 （达到额外奖励最大天数时，继续签到不会再获得额外奖励，断签后重新开始计算)": "Dodatne nagrade za zaporedne prijave (Ko dosežete največje število dni z dodatnimi nagradami, nadaljnje prijave ne bodo več prejele dodatnih nagrad; štetje se začne znova po izostanku prijave)",
  "额外奖励": "Dodatna nagrada",
  "连续签到": "Zaporedne prijave",
  "请输入连续签到天数": "Prosim, vnesite število zaporednih prijav",
  "积分奖励": "Točkovne nagrade",
  "送": "darovanje",
  "请输入连续签到天数的积分": "Prosim, vnesite točke za zaporedne prijave",
  "规则": "Pravila",
  "规则说明": "Obrazložitev pravil",
  "请添加至少一项额外奖励！": "Prosim, dodajte vsaj eno dodatno nagrado!",
  "天数不能为空！": "Dnevi ne smejo biti prazni!",
  "请输入连续签到积分数！": "Prosim, vnesite točke za zaporedne prijave!",
  "每日签到送积分有误": "Napaka v nagradi za dnevne prijave",
  "恭喜你，保存成功": "Čestitke, uspešno shranjeno",
  "连续签到天数": "Dnevi zaporednih prijav",
  "不限": "Neomejeno",
  "签到时间": "Čas prijave",
  "时间": "Čas",
  "请输入用户昵称": "Prosim, vnesite uporabniško ime",
  "签到日期": "Datum prijave",
  "活动奖品": "Nagrade za dogodek",
  "取号记录": "Zapisi o številkah",
  "桌号管理": "Upravljanje miz",
  "取号设置": "Nastavitve rezervacije številk",
  "请输入手机号": "Prosim, vnesite telefonsko številko",
  "待叫号": "Čakanje na poziv",
  "就餐号": "Številka v restavraciji",
  "就餐人数": "Število gostov",
  "桌位名称": "Ime mize",
  "取号时间": "Čas rezervacije številke",
  "待取号": "Čakanje na rezervacijo",
  "已入座": "Usedeno",
  "已过号": "Zamujeno",
  "是否开启打印": "Omogoči tiskanje",
  "须知": "Navodila",
  "请输入须知": "Prosim, vnesite navodila",
  "商家说明": "Opis trgovca",
  "请输入商家说明": "Prosimo, vnesite opis trgovca",
  "取号规则": "Pravila rezervacije številk",
  "等待时间": "Čas čakanja",
  "人数最小值": "Najmanjše število oseb",
  "人数最大值": "Največje število oseb",
  "等待时间(分钟)": "Čas čakanja (minute)",
  "请输入桌位名称": "Prosim, vnesite ime mize",
  "请输入人数最小值": "Prosim, vnesite najmanjše število oseb",
  "请输入人数最大值": "Prosim, vnesite največje število oseb",
  "请输入等待时间": "Prosim, vnesite čas čakanja",
  "商品设置": "Nastavitve izdelka",
  "兑换记录": "Zapisi o zamenjavah",
  "活动名称": "Ime dogodka",
  "请输入活动名称": "Prosim, vnesite ime dogodka",
  "活动列表": "Seznam dogodkov",
  "添加活动": "Dodaj dogodek",
  "活动价格": "Cena dogodka",
  "发放数量": "Količina razdelitve",
  "参与人数": "Število udeležencev",
  "终止": "Prenehaj",
  "购买记录": "Zapisi o nakupih",
  "新增活动会场": "Dodaj novo prizorišče dogodka",
  "活动标题": "Naslov dogodka",
  "请输入活动标题": "Vnesite naslov dogodka",
  "活动日期": "Datum dogodka",
  "礼包设置": "Nastavitve darilnega paketa",
  "优惠券id": "ID kupona",
  "购买设置": "Nakupne nastavitve",
  "购买金额": "Znesek nakupa",
  "会员购买等级": "Nakupna stopnja članov",
  "指定等级": "Določena stopnja",
  "购买次数": "Število nakupov",
  "限购": "Omejitev nakupa",
  "每人限购": "Omejitev nakupa na osebo",
  "次": "krat",
  "发放设置": "Nastavitve razdeljevanja",
  "请输入发放数量": "Prosim, vnesite količino razdelitve",
  "返回": "Vrni se",
  "请勿重复添加": "Prosim, ne dodajajte podvojenih elementov",
  "至少选择一个优惠券": "Izberite vsaj en kupon",
  "新增活动": "Dodaj nov dogodek",
  "券包设置": "Nastavitve paketa kuponov",
  "下载推广码": "Prenesi promocijsko kodo",
  "下载类型": "Vrsta prenosa",
  "使用该功能前，需前往小程序后台，在“设置”-“接口设置”-“公众号关注组件”中设置要展示的公众号。注：设置的公众号需与小程序主体一致": "Pred uporabo te funkcije pojdite v ozadje mini programa, in v 'Nastavitve'-'Nastavitve vmesnika'-'Spremljanje računa javnosti' nastavite račun javnosti, ki naj bo prikazan. Opomba: določen račun javnosti mora ustrezati entiteti mini programa",
  "去配置": "Pojdi na konfiguracijo",
  "若没有配置公众号，功能将不生效": "Če ni konfiguriranega računa javnosti, funkcija ne bo delovala",
  "在一个小程序的生命周期内，只有从以下场景进入小程序，才具有展示引导关注公众号的能力": "Samo vstop v mini program iz naslednjih scen v ciklu življenja mini programa omogoča sposobnost prikazovanja in usmerjanja v sledenje javnemu računu",
  "当小程序从扫小程序码打开时": "Ko se mini program odpre s skeniranjem mini programa",
  "当从其他小程序返回小程序时，若小程序之前未被销毁，则该组件保持上一次打开小程序时的状态": "Ko se vrnete v mini program iz drugega mini programa, če prejšnji mini program ni bil uničen, ta komponenta ohranja stanje, ki je bilo zadnjič odprto mini programa",
  "公众号关注": "Spremljanje javnih računov",
  "新客设置": "Nastavitve novih strank",
  "是否开启活动": "Ali je aktivnost omogočena?",
  "活动时间": "Čas dogodka",
  "背景图": "Ozadje",
  "赠送优惠券": "Darovanje kupona",
  "请选择优惠券": "Prosim, izberite kupon",
  "赠送积分": "Darovanje točk",
  "请输入赠送积分": "Prosim, vnesite število darovanih točk",
  "直播同步": "Sinhronizacija v živo",
  "同步直播": "Sinhroniziraj v živo",
  "请输入直播间名称/主播昵称": "Prosim, vnesite ime živega prostora/voditelja",
  "直播间ID": "ID živega prostora",
  "直播间名称": "Ime živega prostora",
  "主播昵称": "Voditeljev vzdevek",
  "直播开始时间": "Začetek v živo",
  "直播结束时间": "Konec v živo",
  "直播间状态": "Stanje živega prostora",
  "置顶": "Pripni na vrh",
  "未置顶": "Ni na vrhu",
  "已置顶": "Pripeto na vrhu",
  "设为置顶": "Nastavi kot vrh",
  "取消置顶": "Odstrani s vrha",
  "直播中": "V živo",
  "未开始": "Ni začeto",
  "已结束": "Končano",
  "禁播": "Zakleni predvajanje",
  "暂停": "Začasno ustavi",
  "异常": "Neobičajno",
  "已过期": "Poteklo",
  "置顶成功": "Uspešno pritrjeno na vrhu",
  "邀请活动": "Povabilni dogodek",
  "个人中心图片": "Slika osebnega središča",
  "请输入用户昵称/手机号": "Prosim, vnesite uporabniško ime/telefonsko številko",
  "邀请人": "Vabljivec",
  "被邀请人": "Povabljenec",
  "参加时间": "Čas udeležbe",
  "个人中心显示": "Prikaz osebnega središča",
  "参与记录": "Zapisnik sodelovanja",
  "礼品记录": "Zapisi o darilih",
  "推广二维码": "Promocijska QR koda",
  "编辑活动会场": "Uredi prizorišče dogodka",
  "请输入分享标题": "Prosim, vnesite naslov za deljenje",
  "请输入分享内容": "Prosimo, vnesite vsebino deljenja",
  "分享内容": "Vsebina za deljenje",
  "分享图": "Slika za deljenje",
  "个人中心状态": "Stanje osebnega središča",
  "邀请成功的条件": "Pogoji za uspešno povabilo",
  "邀请成为会员": "Povabi za članstvo",
  "邀请成为会员且消费": "Povabi za članstvo in nakup",
  "礼品设置": "Nastavitve daril",
  "奖项": "Nagrada",
  "每邀请": "Na vsako povabilo",
  "人获得礼品": "oseba prejme darilo",
  "添加奖励项": "Dodaj nagrado",
  "请上传背景图": "Prosim, naložite ozadje",
  "请上传分享图": "Prosim, naložite sliko za deljenje",
  "请添加奖项": "Prosim, dodajte nagrado",
  "开启首页推送": "Omogoči sporočilo na začetnem zaslonu",
  "建议换活动，此名称更换，商城首页弹窗根据此名称不同来弹窗": "Priporočamo zamenjavo dogodka; sprememba tega imena bo prilagodila pojavno okno na začetnem zaslonu trgovine glede na to ime",
  "类型": "Vrsta",
  "图文": "Slikovno-besedilno",
  "纯图": "Samo slika",
  "领取优惠券": "Prejmi kupon",
  "请输入标题": "Prosim, vnesite naslov",
  "弹窗图片": "Slika pojavljajočega okna",
  "图片为2M以内大小，格式限png，jpg格式": "Velikost slike naj bo manjša od 2 MB in v formatu PNG ali JPG",
  "建议尺寸": "Priporočena velikost",
  "按钮文案": "Besedilo gumba",
  "简介说明": "Kratek opis",
  "请输入说明": "Vnesti opis",
  "点击选择你要链接的位置": "Kliknite, da označite želeno povezavo",
  "跳转地址": "Naslov preusmeritve",
  "最多可以添加三张": "Do treh dodatkov dovoljeno",
  "最多添加3张优惠券": "Največje omejitev dodajanja: 3 kuponov",
  "标题不能为空": "Naslov ne sme ostati prazen",
  "请选择跳转链接": "Izberite preusmeritveno povezavo",
  "请选择优惠卷": "Izberite kupon",
  "请上传图片": "Prosim, naložite sliko",
  "团购订单": "Naročila za skupinsko nakupovanje",
  "团购管理": "Upravljanje skupinskih nakupov",
  "团购设置": "Nastavitve skupinskih nakupov",
  "订单设置": "Nastavitve naročil",
  "未支付订单": "Neplačana naročila",
  "请输入关闭时间": "Vnesite čas zaprtja",
  "团购保障": "Zagotovilo skupinskega nakupa",
  "使用门店": "Uporaba trgovin",
  "待付款": "Čakajoče plačilo",
  "待使用": "Čakajoče uporabe",
  "已取消": "Preklicano",
  "已退款": "Vračilo",
  "使用门店名称": "Ime trgovine za uporabo",
  "门店联系人": "Kontakt trgovine",
  "门店电话": "Telefonska številka trgovine",
  "团购信息": "Informacije o skupinskem nakupu",
  "券码信息": "Informacije o kodi kupona",
  "核销券码": "Vnovči kodo kupona",
  "添加团购": "Dodaj skupinski nakup",
  "团购名称": "Ime skupinskega nakupa",
  "销售价格": "Prodajna cena",
  "虚拟销量": "Navidezna prodaja",
  "部分": "Delno",
  "基础设置": "Osnovne nastavitve",
  "购买须知": "Navodila za nakup",
  "团购详情": "Podrobnosti skupinskega nakupa",
  "团购须知": "Navodila za skupinski nakup",
  "请输入团购名称": "Vnesite ime skupinskega nakupa",
  "到期类型": "Vrsta poteka",
  "购买后生效": "Veljavnost po nakupu",
  "固定时间": "Fiksni čas",
  "有效天数": "Veljavnost v dnevih",
  "请输入有效天数": "Vnesite veljavnost v dnevih",
  "有效时间": "Veljaven čas",
  "请输入有效时间": "Vnesite veljaven čas",
  "团购图片": "Slika skupinskega nakupa",
  "请上传团购图片": "Naložite sliko skupinskega nakupa",
  "请输入划线价格": "Vnesite prečrtano ceno",
  "请输入销售价格": "Vnesite prodajno ceno",
  "请输入虚拟销量": "Vnesite navidezno prodajo",
  "适用门店": "Veljavne trgovine",
  "请选择门店": "Izberite trgovino",
  "团购状态": "Stanje skupinskega nakupa",
  "每日限购数量": "Dnevna omejitev nakupa",
  "每个会员每日购买的最大数量，0为不限购": "Največje število izdelkov, ki jih lahko vsak član kupi dnevno; 0 pomeni brez omejitve",
  "商家名称": "Ime trgovca",
  "平台": "Platforma",
  "满类型": "Vrsta kriterija",
  "满额": "Minimalni znesek",
  "满件数": "Minimalno število kosov",
  "满值": "Minimalna vrednost",
  "减类型": "Vrsta odštetja",
  "减金额": "Znesek odštete",
  "打折": "Popust",
  "减值": "Vrednost odštete",
  "编辑活动": "Uredi aktivnost",
  "满金额": "Minimalni znesek",
  "请输入满值": "Vnesite minimalno vrednost",
  "如果是打折，填写80，表示打8折": "Če gre za popust, vnesite 80, kar pomeni 20% popusta",
  "满额免配送费设置": "Brezplačna dostava ob minimalnem znesku",
  "是否开启满额免配送费": "Omogoči brezplačno dostavo ob minimalnem znesku",
  "单笔订单满": "Enkratno naročilo nad",
  "如果开启满额免配送费，设置0为全场免配送费": "Če je omogočena brezplačna dostava ob minimalnem znesku, nastavite 0 za celotno naročilo",
  "入驻申请": "Vloga za nastanitev",
  "配送员": "Dostavni delavec",
  "配送订单": "Dostava naročil",
  "提现申请": "Vloga za dvig",
  "配送设置": "Nastavitve dostave",
  "退出申请": "Vloga za izhod",
  "正常": "Običajno",
  "押金": "Varščina",
  "累计佣金": "Skupni zaslužek",
  "可提现佣金": "Dosegljiva provizija za dvig",
  "已提现佣金": "Izplačana provizija",
  "提现明细": "Podrobnosti dviga",
  "申请条件": "Pogoji za vlogo",
  "结算": "Poravnava",
  "是否开启押金支付": "Omogoči plačilo varščine",
  "是否审核": "Zahteva pregled",
  "需后台审核": "Pregled preko ozadja",
  "无需审核": "Brez potrebnega pregleda",
  "产品列表弹出层": "Priroček seznama izdelkov",
  "已选择该商品": "Izdelek že izbran",
  "注：如使用微信支付，则需申请微信支付企业付款到零钱功能": "Opomba: Za uporabo WeChat plačila je potrebno zaprositi za poslovno plačilo na račun v hrbtni valuti",
  "微信提现方式": "Metoda dviga s WeChatom",
  "微信提现到零钱": "Dvig s WeChatom v denarnico",
  "商家转账到零钱": "Prenos trgovca v denarnico",
  "注：根据实际产品开通情况选择": "Izberite glede na dejansko aktivacijo izdelka",
  "最低提现额度": "Minimalni znesek za dvig",
  "佣金结算时间": "Čas izračuna provizije",
  "注：当订单完成n小时后，该订单的配送佣金才会结ati do distributionskega stanja dostavljavca; če je nastavljen na 0 ur, se izračuna ob končanju naloga": "Opomba: Distributionske provizije se izračunajo v distribucijski račun n ur po končanem naročilu; Nastavitev na 0 ur se izračuna takoj ob končanju naročila",
  "请至少选择一种提现方式": "Izberite vsaj en način dviga",
  "佣金结算": "Izračun provizije",
  "是否结算佣金": "Ali hčete izračunati provizijo?",
  "已结算": "Izračunano",
  "未结算": "Ni izračunano",
  "送达状态": "Stanje dostave",
  "查看详情": "Ogled podrobnosti",
  "该操作将使用微信支付企业付款到零钱功能，确定打款吗？": "Ta operacija bo uporabila WeChat podjetniško plačilo na račun, ste prepričani, da želite izvesti transakcijo?",
  "身份证号": "Številka osebne izkaznice",
  "待交押金": "Čakanje na varščino",
  "审核方式": "Način pregleda",
  "查看": "Preglej",
  "配送员审核": "Pregled dostavnega osebja",
  "添加外卖商品": "Dodaj restavracijske izdelke",
  "序号": "Številka",
  "活动折扣": "Popust na dogodek",
  "活动库存": "Zaloge dogodka",
  "添加店内商品": "Dodaj izdelke v trgovini",
  "优惠券列表": "Seznam kuponov",
  "发送优惠券": "Pošlji kupone",
  "发送对象": "Prejemnik",
  "全站会员": "Vsi člani strani",
  "指定会员": "Določeni člani",
  "选择会员等级": "Izberi raven članstva",
  "发送的优惠券会员领取已达到限制数量，将不再发送给该会员": "Kuponi, poslani članu, so dosegli omejitev prejema; zato mu ne bodo več poslani",
  "发送成功": "Pošiljanje uspešno",
  "优惠券ID": "ID kupona",
  "优惠券名称": "Ime kupona",
  "优惠券类型": "Vrsta kupona",
  "最低消费金额": "Minimalni znesek za nakup",
  "优惠方式": "Način popusta",
  "立减": "Neposredni popust ",
  "打": "Popust",
  "领取": "Prejmi",
  "天内有效": "Veljavnost v dnevih",
  "发放总数量": "Skupno število distribucije",
  "不限制": "Brez omejitev",
  "已领取数量": "Število prejetih",
  "修改优惠券": "Uredi kupon",
  "请输入优惠券名称": "Vnesite ime kupona",
  "例如：满100减10": "Na primer: Ob nakupu nad 100, popust 10",
  "优惠券颜色": "Barva kupona",
  "蓝色": "Modra",
  "红色": "Rdeča",
  "紫色": "Vijolična",
  "黄色": "Rumena",
  "满减券": "Kupon za popust",
  "折扣券": "Kupon za popust",
  "减免金额": "Znižan znesek",
  "请输入减免金额": "Vnesite znižan znesek",
  "折扣率": "Stopnja popusta",
  "请输入折扣率": "Vnesite stopnjo popusta",
  "折扣率范围0-10，9.5代表9.5折，0代表不折扣": "Območje popusta je med 0 in 10, na primer 9.5 pomeni 5% popust, 0 pa brez popusta",
  "请输入最低消费金额": "Vnesite minimalni znesek za nakup",
  "后生效": "Veljaven po",
  "请输入发放总数量": "Vnesite skupno število distribucije",
  "限制领取的优惠券数量，-1为不限制": "Omeji število prejetih kuponov, -1 za neomejeno",
  "是否显示在领券中心": "Ali naj bo prikazano v središču za prejemanje kuponov?",
  "新用户首次进入小程序的时候才会显示如图所示的弹窗提示，只显示一次": "Novim uporabnikom se pri prvem obisku mini programa prikaže opozorilno okno kot prikazano na sliki; prikazano bo samo enkrat",
  "引导收藏": "Vodenje zbiranja",
  "编辑类型": "Uredi tip",
  "生日设置": "Nastavitev rojstnega dne",
  "手机短信": "SMS",
  "分销商用户": "Uporabniki distribucije",
  "分销订单": "Distribucijska naročila",
  "分销海报": "Distribucijski plakati",
  "推荐人": "Priporočevalec",
  "下级用户": "Spodnji uporabniki",
  "一级": "Prva stopnja",
  "二级": "Druga stopnja",
  "三级": "Tretja stopnja",
  "成为时间": "Čas pridružitve",
  "下级": "Spodnja stopnja",
  "加入时间": "Čas pridružitve",
  "分销商条件": "Pogoji distributerja",
  "佣金设置": "Nastavitve provizije",
  "自定义文字": "Prilagojeno besedilo",
  "申请协议": "Pogodba za vlogo",
  "页面背景图": "Slika ozadja strani",
  "分销中心页面": "Stran distribucijskega centra",
  "页面标题": "Naslov strani",
  "分销中心": "Distribucijski center",
  "非分销商提示": "Nasvet za ne-distributerje",
  "您还不是分销商，请先提交申请": "Še niste distributer, najprej oddajte vlogo",
  "申请成为分销商": "Vložitev vloge za distributerja",
  "立即加入": "Takoj se pridružite",
  "可提现": "Dosegljivo za dvig",
  "待提现佣金": "Provizija za dvig v čakanju",
  "待提现": "Čakanje na dvig",
  "已提现金额": "Skupni znesek dviga",
  "去提现": "Pojdi na dvig",
  "申请成为分销商页面": "Stran vloge za distributerja",
  "请填写申请信息": "Izpolnite podatke za vlogo",
  "分销商申请协议": "Pogodba za vlogo distributerja",
  "申请成为经销商": "Vložitev vloge za prodajalca",
  "审核中提示信息": "Sporočilo o pregledu v teku",
  "您的申请已受理，正在进行信息核验，请耐心等待。": "Vaša vloga je bila sprejeta in trenutno preverjamo informacije. Prosimo, bodite potrpežljivi",
  "去商城逛逛": "Kliknite za obisk trgovine",
  "分销订单页面": "Stran distribucijskega naročila",
  "我的团队页面": "Moja stran ekipe",
  "团队总人数": "Skupno število članov ekipe",
  "一级团队": "Primarna ekipa",
  "二级团队": "Sekundarna ekipa",
  "三级团队": "Terciarna ekipa",
  "提现明细页面": "Stran s podrobnostmi dviga",
  "审核中": "V pregledu",
  "申请提现页面": "Stran zahteve za dvig",
  "申请提现": "Pošlji zahtevo za dvig",
  "请输入要提取的金额": "Prosim vnesite želeni znesek za dvig",
  "最低提现佣金": "Minimalna provizija za dvig",
  "提交申请": "Pošlji vlogo",
  "佣金结算天数": "Dnevi obračuna provizije",
  "注：当订单完成n天后，该订单的分销佣金才会结算到分销商余额，如果设置为0天,则订单完成时就结算": "Opomba: Provizija iz naročila bo obračunana distributerjevemu stanju n dni po končanem naročilu. Če je nastavljeno na 0 dni, bo obračunana ob končanju naročila",
  "成为分销商条件": "Pogoji za postati distributer",
  "购买指定商品成为分销商": "Postanite distributer z nakupom določenih izdelkov",
  "购买指定商品付款后自动成为分销商，无需后台审核": "Samodejno postanite distributer po plačilu določenih izdelkov, brez pregleda ozadja",
  "选择商品": "Izberite izdelke",
  "成为下线条件": "Pogoji za postati podrejeni",
  "首次点击分享链接": "Prvo kliknite na deljeno povezavo",
  "一级佣金比例": "Odstotek primarne provizije",
  "佣金比例范围 0% - 100%": "Območje odstotka provizije 0% - 100%",
  "二级佣金比例": "Odstotek sekundarne provizije",
  "三级佣金比例": "Odstotek terciarne provizije",
  "是否开启分销功能": "Omogoči funkcijo distribucije",
  "分销层级": "Nivoji distribucije",
  "一级分销": "Primarna distribucija",
  "二级分销": "Sekundarna distribucija",
  "三级分销": "Terciarna distribucija",
  "分销商内购": "Distributerjev lasten nakup",
  "如开启，分销商自己购买商品，获得一级佣金": "Če je omogočeno, distributerji prejmejo primarno provizijo za svoje nakupe",
  "分销中心首页": "Glavna stran distribucijskega centra",
  "尺寸：宽750像素 高度227像素": "Dimenzije: Širina 750 slikovnih pik, Višina 227 slikovnih pik",
  "申请成为分销商页": "Stran za vlogo v distribuciji",
  "申请提现页": "Stran zahteve za dvig",
  "分销海报设置": "Nastavitve distribucijskih plakatov",
  "海报背景图": "Slika ozadja plakata",
  "尺寸：宽750像素 高大于(等于)1200像素": "Dimenzije: Širina 750 slikovnih pik, Višina več kot ali enako 1200 slikovnih pik",
  "头像宽度": "Širina profila",
  "头像样式": "Slog profila",
  "正方形": "Kvadrat",
  "圆形": "Krog",
  "昵称字体大小": "Velikost pisave psevdonima",
  "昵称字体颜色": "Barva pisave psevdonima",
  "小程序码宽度": "Širina kode mini programa",
  "小程序码样式": "Slog kode mini programa",
  "分销商": "Distributer",
  "一级分销商": "Primarni distributer",
  "用户": "Uporabnik",
  "分销佣金": "Provizija distributerja",
  "二级分销商": "Sekundarni distributer",
  "三级分销商": "Terciarni distributer",
  "分销商审核": "Pregled distributerja",
  "积分明细": "Podrobnosti točk",
  "变动数量": "Količina spremembe",
  "积分名称": "Ime točk",
  "例": "Primer",
  "修改积分名称后，在买家端的所有页面里，看到的都是自定义的名称": "Po spreminjanju imena točk bo prilagojeno ime prikazano na vseh straneh kupca",
  "商家使用自定义的积分名称来做品牌运营。如京东把积分称为“京豆”，淘宝把积分称为“淘金币”": "Podjetja uporabljajo prilagojena imena točk za blagovno znamko. Na primer, JD imenuje točke 'JD Beans', Taobao pa jih imenuje 'Treasure Coins'",
  "积分说明": "Opis točk",
  "积分赠送": "Podarjene točke",
  "是否开启购物送积分": "Omogoči točke za nakup",
  "积分赠送规则": "Pravila podarjanja točk",
  "如开启则订单完成后赠送用户积分": "Če je omogočeno, uporabnikom se pri nakupu dodelijo točke po končanju naročila",
  "订单确认收货已完成": "Potrditev naročila in prejemanje je končano",
  "已完成订单超出后台设置的申请售后期限": "Končana naročila presegajo rok zahtevka po prodaji v ozadju",
  "积分赠送比例": "Razmerje podarjenih točk",
  "赠送比例请填写数字0~100；订单的运费不参与积分赠送": "Prosim vnesite razmerje med 0 in 100; stroški pošiljanja niso vključeni v podarjanje točk",
  "订单付款金额(100.00€) * 积分赠送比例(100%) = 实际赠送的积分(100积分)": "Znesek plačila naročila (100,00 €) * Razmerje podarjenih točk (100%) = Dejanske dodeljene točke (100 točk)",
  // =====================  营销工具end   ==========

  // =====================  数据统计 start   ==========
  "销售统计": "Statistika prodaje",
  "会员统计": "Statistika članov",
  "订单概况": "Pregled naročil",
  "商品概况": "Pregled izdelkov",
  "今日": "Danes",
  "累积会员数": "Skupno članov",
  "新增会员数": "Novi člani",
  "成交会员数": "Število transakcijskih članov",
  "排行榜": "Rang lista",
  "用户消费榜": "Razvrstitev porabe uporabnika",
  "积分排行榜": "Rangiranje točk",
  "邀请人排行榜": "Rangiranje povabiteljev",
  "成交会员占比": "Odstotek transakcijskih članov",
  "今天": "Danes",
  "最近7天": "Preteklih 7 dni",
  "最近30天": "Preteklih 30 dni",
  "最近90天": "Preteklih 90 dni",
  "最近180天": "Preteklih 180 dni",
  "最近1年": "Preteklo leto",
  "最近2年": "Preteklih 2 leti",
  "所有占比": "Skupni odstotek",
  "成交会员": "Transakcijski člani",
  "未成交会员": "Ne-transakcijski člani",
  "新增会员": "Novi člani",
  "最近一周": "Prejšnji teden",
  "最近一个月": "Prejšnji mesec",
  "最近三个月": "Zadnji trije meseci",
  "选择店铺": "Izberite trgovino",
  "查询日期": "Datum poizvedbe",
  "近七天": "Zadnjih sedem dni",
  "近十五天": "Zadnjih petnajst dni",
  "自定义时间": "Prilagojen čas",
  "日期": "Datum",
  "有效订单数": "Število veljavnih naročil",
  "选择时间": "Izberite čas",
  "交易统计": "Statistika transakcij",
  "订单数": "Število naročil",
  "客单价": "Povprečna vrednost naročila",
  "付款订单": "Plačana naročila",
  "付款人数": "Število plačujočih strank",
  "商品统计": "Statistika izdelkov",
  "在售商品": "Razpoložljivi izdelki",
  "件": "Predmet",
  "已付款商品": "Plačani izdelki",
  "销量TOP10": "Najboljših 10 prodaj",
  "浏览TOP10": "Najboljših 10 ogledov",
  "浏览": "Ogled",
  "排行类型": "Vrsta rangiranja",
  "商品总数": "Skupno število izdelkov",
  "已上架商品": "Dostopni izdelki",
  "已下架商品": "Nedostopni izdelki",
  "商品导出": "Izvoz izdelkov",
  "商品总销量": "Skupna prodaja izdelkov",
  "商品总销售额": "Skupni znesek prodaje izdelkov",
  "资产总览": "Pregled sredstev",
  "财务对账": "Finančno usklajevanje",
  "交易记录": "Zapisi transakcij",
  "店铺结算": "Poravnava trgovine",
  "待结算金额": "Znesek čakanja na poravnavo",
  "已结算金额": "Poravnani znesek",
  "交易概况": "Pregled transakcij",
  "外卖统计": "Statistika s prevzemom",
  "店内统计": "Statistika v trgovini",
  "订单类型": "Vrsta naročila",
  "应收金额": "Znesek, ki ga je treba prejeti",
  "实付金额": "Plačani znesek",
  "账户概况": "Pregled računa",
  "订单编号": "Številka naročila",
  "支付状态": "Stanje plačila",
  "付款方式": "Način plačila",
  "订单费用": "Stroški naročila",
  "优惠": "Popust",
  "商户实际收入": "Dejanski prihodek trgovca",
  "商品ID": "ID izdelka",
  "小计": "Skupna vsota",
  "请输入提现金额": "Vnesite znesek dviga",
  "请输入打款方式": "Vnesite način plačila",
  "支付宝真实姓名": "Pravo ime Alipay",
  "请输入支付宝真实姓名": "Vnesite pravo ime Alipay",
  "开户行名称": "Ime banke",
  "银行开户名": "Ime bančnega računa",
  "真实姓名": "Pravo ime",
  "应付金额": "Znesek plačila",
  "实付总额": "Skupni plačani znesek",
  "商户": "Trgovec",
  "结算金额": "Znesek poravnave",
  "店铺结算金额": "Znesek poravnave trgovine",
  "操作提示": "Namigi za delovanje",
  "订单结算金额 = 店铺结算总金额(含运费)": "Znesek poravnave naročila = Skupni znesek poravnave trgovine (vključno s stroški pošiljanja)",
  "店铺收入金额 = 店铺结算总金额 - 店铺退款金额": "Prihodek trgovine = Skupni znesek poravnave trgovine - Znesek vračila trgovine",
  "订单日期": "Datum naročila",
  "订单结算金额": "Znesek poravnave naročila",
  "配送费金额": "Znesek stroškov dostave",
  "商品编码": "Šifra izdelka",
  "可用余额": "Razpoložljivi saldo",
  "提现概况": "Pregled dviga",
  "搜索": "Iskanje",
  "支出": "Izdatek",
  "金额": "Znesek",
  "收支类型": "Vrsta prihodkov in odhodkov",
  "确认要退吗?": "Potrditev za vračilo?",
  "申请成功": "Uspešna vloga",
  "门店总金额": "Skupni znesek trgovine",
  "累计收入": "Skupni prihodek",
  "访客数": "Število obiskovalcev",
  "访问量": "Obiskanost",
  "店铺收藏数": "Število priljubljenih trgovin",
  "商品收藏数": "Število priljubljenih izdelkov",
  "访问数": "Število obiskov",
  "收藏数": "Število priljubljenih",
  "数": "Število",
  "待支付": "Na čakanju za plačilo",
  "实际到账": "Dejansko prejeti znesek",
  // =====================  数据统计 end   ==========

  // ==================== 设置 start ================
  "商城设置": "Nastavitve trgovine",
  "物流公司": "Logistično podjetje",
  "chatgpt设置": "Nastavitve ChatGPT",
  "消息设置": "Nastavitve sporočil",
  "短信设置": "Nastavitve SMS",
  "上传设置": "Nastavitve nalaganja",
  "清理缓存": "Počisti predpomnilnik",
  "网址后缀英文名称": "Angleško ime za spletno končnico",
  "英文名称": "Angleško ime",
  "默认头像": "Privzeta slika profila",
  "英文名称必须只包含数字和英文字母": "Angleško ime mora vsebovati le številke in črke",
  "恭喜你，商城设置成功": "Čestitamo, nastavitve trgovine so uspešno uporabljene",
  "表单数据不符合规则": "Podatki obrazca ne ustrezajo pravilom",
  "剩余额度": "Preostali limit",
  "余额不足时，智能客服、AI魔法创建、多语言翻译等功能将无法使用": "Ko je stanje premalo, se funkcije, kot so pametna služba za stranke, ustvarjanje z umetno inteligenco, in večjezično prevajanje, onemogočijo",
  "使用明细": "Podrobnosti o uporabi",
  "消费": "Poraba",
  "额度": "Kvota",
  "数据缓存": "Predpomnilnik podatkov",
  "恭喜你，清理成功": "Čestitamo, postopek čiščenja je uspešen",
  "管理员列表": "Seznam administratorjev",
  "角色管理": "Upravljanje vlog",
  "登录日志": "Dnevnik prijave",
  "操作日志": "Dnevnik delovanja",
  "添加管理员": "Dodaj administratorja",
  "管理员ID": "ID administratorja",
  "用户名": "Uporabniško ime",
  "所属角色": "Dodeljena vloga",
  "超级管理员": "Super administrator",
  "所属门店": "Pripadajoča trgovina",
  "门店状态": "Stanje trgovine",
  "已删除": "Izbrisano",
  "未删除": "Neizbrisano",
  "账号状态": "Stanje računa",
  "恭喜你，该管理员删除成功": "Čestitamo, administrator je uspešno izbrisan",
  "请输入用户名": "Vnesite uporabniško ime",
  "修改管理员": "Uredi administratorja",
  "添加角色": "Dodaj vlogo",
  "角色ID": "ID vloge",
  "角色名称": "Ime vloge",
  "恭喜你，该角色删除成功": "Čestitamo, vloga je uspešno izbrisana",
  "编辑角色": "Uredi vlogo",
  "请输入角色名称": "Vnesite ime vloge",
  "权限列表": "Seznam dovoljenj",
  "请输入用户名和真实姓名": "Vnesite uporabniško ime in pravo ime",
  "登录状态": "Stanje prijave",
  "全部标记为已读": "Označi vse kot prebrano",
  "公告详情": "Podrobnosti obvestila",
  "全部标记为已读消息吗?": "Označi vse sporočbe kot prebrane?",
  "操作成功!": "Operacija uspešna!",
  "已取消操作": "Operacija preklicana",
  "订单流程设置": "Nastavitve postopka naročanja",
  "已支付订单": "Plačana naročila",
  "分钟后自动关闭": "samodejno zapri po minutah",
  "订单下单未付款，n分钟后自动关闭，设置0不自动关闭": "Naročila so oddana, vendar ne plačana, samodejno zapri po n minutah, nastavi na 0 za ročno zapiranje",
  "分钟后自动核销": "samodejno potrdi po minutah",
  "如果在期间未核销，系统自动完成核销，设置0不自动核销": "Če ni potrjeno v časovnem obdobju, sistem samodejno potrdi, nastavi na 0 za ročno potrditev",
  "积分商城订单流程设置": "Nastavitve postopka naročanja v trgovini z bonusi",
  "已发货订单": "Poslana naročila",
  "天后自动核销": "samodejno potrdi po dneh",
  "不包括桌台订单": "ne vključuje naročil na mizi",
  "恭喜你，交易设置成功": "Čestitamo, nastavitve transakcije so uspešno uporabljene",
  // ==================== 设置 end ================
  // ==================== Layout start ===========
  "当前版本": "Trenutna različica",
  "试用版": "Preizkusna različica",
  "专业版": "Profesionalna izdaja",
  "高级版": "Napredna izdaja",
  "至尊版": "Najvišja izdaja",
  "到期日期": "Datum poteka",
  "永不过期": "Nikoli ne poteče",
  "欢迎您": "Dobrodošli",
  "修改密码": "Spremenite geslo",
  "此操作将退出登录, 是否继续?": "Ta operacija vas bo odjavila, želite nadaljevati?",
  "原始密码": "Izvirno geslo",
  "新密码": "Novo geslo",
  "确认新密码": "Potrdite novo geslo",
  "系统公告": "Sistemsko obvestilo",
  "请至少选择一件产品商品！": "Prosim izberite vsaj en izdelek!",
  "超链接设置": "Nastavitve hiperpovezav",
  "图像预览": "Predogled slike",
  "页面": "Stran",
  "当前链接": "Trenutna povezava",
  "暂无": "Ničesar",
  "页面路径": "Pot strani",
  "注意一": "Opomba ena",
  "注意二": "Opomba dva",
  "注意三": "Opomba tri",
  "同一个小程序链接其他小程序，最多只能链接10个，超过将不生效": "Za isti mini program, ki se povezuje z drugimi mini programi, je dovoljena največ 10 povezav; preseganje te omejitve ne bo uspešno",
  "不能填写自身小程序appid": "Ne morete vnesti ID-ja svojega trenutnega mini programa",
  "小程序链接留空默认跳到小程序首页": "Če pustite prazno polje za povezavo mini programa, bo privzeto skočilo na začetno stran mini programa",
  "分类": "Kategorija",
  "选择": "Izberite",
  "签到": "Prijava",
  "积分商城": "Trgovina s točkami",
  "秒杀": "Hitra prodaja",
  "拼团": "Skupinsko nakupovanje",
  "砍价": "Prenizka cena",
  "领券中心": "Center za kupončke",
  "生日有礼": "Darilo za rojstni dan",
  "链接的网页必须支持SSL ，链接必须以 https:// 开头，否则无法跳转": "Povezana spletna stran mora podpirati SSL in se začeti s https://, sicer ne bo mogoče preusmeriti",
  "链接的域名必须是备案域名，否则无法跳转": "Povezan domenski naslov mora biti registriran, sicer se preusmeritev ne bo izvedla",
  "您的网站域名必须加到微信小程序公众平台的业务域名处,详细说明？": "Vaše domensko ime spletnega mesta mora biti dodano na poslovni domenski meni WeChat Mini Program Public Platform, ali lahko podate podrobnejše informacije?",
  "选择文章列表": "Izberite seznam člankov",
  "文章标题": "Naslov članka",
  "文章分类": "Kategorija članka",
  "选择规格": "Izberite specifikacije",
  "产品/规格": "Izdelek/Specifikacije",
  "已选": "Izbrano",
  "查看物流": "Ogled logistike",
  "请输入收货人": "Prosimo vnesite prejemnika",
  "请输入收获电话": "Prosimo vnesite telefonsko številko prejemnika",
  "省": "Pokrajina",
  "市": "Mesto",
  "区": "Okrožje",
  "现金收款": "Gotovinsko plačilo",
  "余额收款": "Plačilo z naloženim zneskom",
  "其他方式": "Druge metode",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Prosimo vnesite ID člana za iskanje člana, nato kliknite potrdi, ko končate",
  "请输入会员ID": "Vnesite ID člana",
  "会员昵称": "Vzdevek člana",
  "余额总计": "Skupni naloženi znesek",
  "登录会员仅作为积分累计，无法享受其他优惠": "Prijavljeni člani lahko le kopičijo točke in ne morejo uživati drugih popustov",
  "取消收款": "Prekliči plačilo",
  "收款": "Prejmi plačilo",
  "请输入会员手机号": "Prosimo vnesite telefonsko številko člana",
  "该用户不存在": "Ta uporabnik ne obstaja",
  "注册": "Registracija",
  "平台名称": "Ime platforme",
  "请输入平台名称": "Prosimo vnesite ime platforme",
  "所在地区": "Lokacija",
  "请选择所在地区": "Prosimo izberite lokacijo",
  "平台账户名": "Ime platforme računa",
  "请输入平台账户名": "Prosimo vnesite ime platforme računa",
  "平台账户密码": "Geslo platforme računa",
  "是否连锁": "Ali je to veriga?",
  "是": "Da",
  "否": "Ne",
  "请输入您的地址": "Prosimo vnesite svoj naslov",
  "请输入您的联系电话": "Prosimo vnesite svojo kontakt telefonsko številko",
  "请输入您的联系邮箱": "Prosimo vnesite svoj kontakt e-poštni naslov",
  "联系邮箱": "E-pošta za stik",
  "不能全是空格": "Ne sme biti samo presledkov",
  "不能包含空格": "Ne sme vsebovati presledkov",
  "长度不能小于6位": "Dolžina ne sme biti manjša od 6 znakov",
  "请填写确认密码": "Prosimo vnesite potrditveno geslo",
  "确认密码不一致": "Gesli se ne ujemata",
  "联系电话和联系邮箱至少填写一个": "Prosimo navedite vsaj en kontaktan telefonsko številko ali e-poštni naslov",
  "注册成功,请前往登录": "Registracija je uspešna, prosimo nadaljujte z vpisom",
  "清空": "Počisti",
  "确认": "Potrdi",
  "限时免费": "Omejen čas brezplačno",
  // ==================== Components end     =========

  // ==================== 其它  start    ==============
  "菜品总量": "Skupna količina jedi",
  "菜品排行榜": "Seznam jedi",
  "商家信息": "Informacije o trgovcu",
  "与店内营业时间相同": "Enako kot delovni čas trgovine",
  "菜品": "Jedi",
  "菜品分类": "Kategorizacija jedi",
  "添加菜品": "Dodajanje jedi",
  "通告": "Obvestilo",
  "商家店名": "Ime trgovca",
  "请输入商家店名": "Prosimo, vnesite ime trgovca",
  "温馨提示：选择后，请勿随意修改，以免造成门店菜品数据错乱": "Nežen opomnik: Po izbiri se izogibajte naključnim spremembam, da preprečite motnje v podatkih o jedeh v trgovini",
  "网址后缀设置": "Nastavitev priponke URL-ja",
  "选填，设置后缀可替换下列网址末尾的数字id，方便记忆": "Izbirno: Nastavitev priponke lahko zamenja številski ID na koncu naslednjih URL-jev za lažje zapomnjevanje",
  "网址设置": "Nastavitve URL-ja",
  "手机网站二维码": "QR koda za mobilno spletno mesto",
  "按菜品收费": "Zaračunavanje po jedi",
  "外卖菜品": "Hrana za dostavo",
  "店内菜品": "Jedi v restavraciji",
  "菜品管理": "Upravljanje jedi",
  "菜品名称": "Ime jedi",
  "请输入菜品名称": "Prosimo, vnesite ime jedi",
  "此菜品正在参加活动，不能修改规格": "Ta jed sodeluje v dogodku, specifikacije ni mogoče spreminjati",
  "通过人工智能技术，可以根据菜品名称自动填写菜品详细信息，如配料、卖点、口味等。": "Z umetniško inteligenco je mogoče glede na ime jedi samodejno izpolniti podrobne informacije o jedi, kot so sestavine, prodajne točke, okusi itd.",
  "请填写菜品详情": "Prosim izpolnite podrobnosti jedi",
  "菜品详情": "Podrobnosti jedi",
  "菜品图片": "Slika jedi",
  "请上传菜品图片": "Prosim, naložite sliko jedi",
  "AI未识别到您的菜品图片": "AI ni prepoznal vaše slike jedi",
  "本菜品正在参加活动，不能删除规格！": "Ta jed sodeluje v dogodku, specifikacije ni mogoče brisati!",
  "菜品加料": "Dodatki jedi",
  "菜品状态": "Status jedi",
  "选择菜品状态": "Izberite status jedi",
  "菜品排序": "Razporeditev jedi",
  "请填写菜品名称": "Prosim, vnesite ime jedi",
  "你选择菜品分类": "Izbrali ste kategorijo jedi",
  "菜品卖点": "Posebnost jedi",
  "菜品属性": "Značilnosti jedi",
  "菜品同步": "Sinhronizacija jedi",
  "是否同步菜品至外卖": "Sinhroniziraj jedi za dostavo",
  "是否同步菜品至店内": "Sinhroniziraj jedi v restavraciji",
  "搜索菜品": "Iskanje jedi",
  "菜品原价": "Osnovna cena jedi",
  "菜品来源": "Vir jedi",
  "菜品列表": "Seznam jedi",
  "菜品价格": "Cena jedi",
  "菜品销量": "Prodaja jedi",
  "通告管理": "Upravljanje obvestil",
  "添加通告": "Dodajanje obvestil",
  "通告ID": "ID obvestila",
  "通告标题": "Naslov obvestila",
  "通告分类": "Kategorija obvestila",
  "通告排序": "Razporeditev obvestil",
  "通告状态": "Status obvestila",
  "通告内容": "Vsebina obvestila",
  "编辑通告": "Urejanje obvestil",
  "AI助理形象选择": "Izbira podobe AI pomočnika",
  "菜品信息": "Informacije o jedeh",
  "菜品总价": "Skupna cena jedi",
  "请按实际店名填写，将显示在商家点餐网站上": "Prosimo, vnesite dejansko ime trgovine, ki bo prikazano na spletnem mestu naročanja hrane trgovca",
  "首次添加桌位请先添加桌位类型": "Pri prvem dodajanju miz najprej dodajte vrste miz",
  "首次添加桌位请先添加区域": "Pri prvem dodajanju miz najprej dodajte območja",
  "设置店内区域，如A区、B区、大厅、包厢等": "Nastavite območja v restavraciji, kot so Območje A, Območje B, predprostor, zasebne sobe, itd.",
  "设置桌位类型，如二人桌、四人桌、大桌、小桌等": "Nastavite vrste miz, kot so miza za dve osebi, miza za štiri osebe, velika miza, mala miza, itd.",
  "该账号用于登录收银台网站（可在“网址设置”页面找到收银台网址）": "Ta račun se uporablja za prijavo na spletno mesto blagajne (naslov spletnega mesta blagajne je mogoče najti na strani 'Nastavitve URL-ja')",
  "该账号用于登录后厨网站（可在“网址设置”页面找到后厨网址）": "Ta račun se uporablja za prijavo na spletno mesto kuhinje (naslov spletnega mesta kuhinje je mogoče najti na strani 'Nastavitve URL-ja')",
  "如无需设置税率可不填写": "Če ni potrebno nastaviti davčne stopnje, je ni treba izpolniti",
  "打款信息": "Informacije o plačilu",
  "开户行": "Banka",
  "菜品分组": "Razvrstitev jedi",
  "自定义名称，仅用于商家自己区分分类，不会展示给顾客": "Prilagojeno ime, uporablja se samo za razlikovanje kategorij s strani trgovcev, ne bo prikazano strankam",
  "手机网站编辑": "Urejanje mobilne strani",
  "恢复初始默认页面": "Obnovitev izvirne privzete strani",
  "通告为手机网站上展示的通知、公告、商家介绍等，“显示”状态时，该篇通告将展示在手机网站上": "Obvestila, prikazana na mobilni spletni strani, vključujejo obvestila, novice, predstavitev trgovcev itd. Ko je v statusu 'Prikaz', bodo ta obvestila prikazana na mobilni spletni strani",
  "菜品重量": "Teža jedi",
  "请填写菜品重量": "Prosim vnesite težo jedi",
  "菜品设置": "Nastavitve jedi",
  "已选择该菜品": "Izbrali ste to jed",
  "添加外卖菜品": "Dodajanje jedi za dostavo",
  "添加店内菜品": "Dodajanje jedi v restavraciji",
  "购买指定菜品成为分销商": "Nakup določenih jedi za postati distributer",
  "购买指定菜品付款后自动成为分销商，无需后台审核": "Po nakupu določenih jedi in plačilu, se samodejno postanite distributer, brez potrebe po odobritvi upravnika",
  "选择菜品": "Izberite jed",
  "如开启，分销商自己购买菜品，获得一级佣金": "Če je omogočeno, lahko distributerji kupujejo jedi sami in prejemajo provizijo prve stopnje",
  "菜品概况": "Pregled jedi",
  "菜品统计": "Statistika jedi",
  "在售菜品": "Jedi na voljo za prodajo",
  "已付款菜品": "Plačane jedi",
  "菜品总数": "Skupno število jedi",
  "已上架菜品": "Razstavljene jedi",
  "已下架菜品": "Odstranjene jedi",
  "菜品导出": "Izvoz jedi",
  "菜品总销量": "Skupna prodaja jedi",
  "菜品总销售额": "Skupni prihodki od prodaje jedi",
  "菜品ID": "ID jedi",
  "菜品编码": "Šifra jedi",
  "菜品收藏数": "Število priljubljenih jedi",
  "请至少选择一件产品菜品！": "Prosimo, izberite vsaj en izdelek!",
  "请输入收货电话": "Prosimo, vnesite telefonsko številko za dostavo",
  "区域管理": "Regionalno Upravljanje",
  "点餐管理系统": "Sistem naročil",
  "首页": "Domov",
  "余额支付": "Plačilo z ostankom",
  "线下支付(现金支付)": "Offline plačilo (gotovina)",
  "线下支付(自有微信支付)": "Offline plačilo (vlastit WeChat Pay)",
  "线下支付(自有支付宝支付)": "Offline plačilo (vlastit Alipay)",
  "线下支付(POS刷卡支付)": "Offline plačilo (kartično plačilo preko POS-a)",
  "待配送": "Za dostavo",
  "配送中": "V dostavi",
  "待接单": "Za sprejem",
  "待取货": "Za prevzem",
  "已配送": "Dostavljeno",
  "已收货": "Prejeto",
  "待收货": "Za prevzem",
  "待取消": "Za odpoved",
  "会员": "Član",
  "商家": "Trgovec",
  "供应商": "Dobavitelj",
  "分销": "Distribucija",
  "通知": "Obvestilo",
  "已付款": "Plačano",
  "用户下单": "Korisnik je oddal naročilo",
  "收银台下单": "Naročilo na blagajni",
  "扫码下单": "Naročilo s čitanjem koda",
  "团购下单": "Skupinski naročilo",
  "商城订单": "Naročilo iz trgovine",
  "积分商城订单": "Naročilo iz trgovine z bodovanjem",
  "余额充值订单": "Naročilo za polnjenje salda",
  "购卡订单": "Naročilo za nakup kartice",
  "券包订单": "Naročilo za kupon paket",
  "配送员押金订单": "Naročilo za zalog dostavnega osebja",
  "快递配送": "Ekspresna dostava",
  "个人中心": "Osebni center",
  "在地图中点击确认位置，坐标自动填入":"S klikom potrdite lokacijo na zemljevidu, koordinate se bodo samodejno izpolnile.",
  "添加优惠券请前往'营销工具'—'插件中心'—'优惠券'页面":"Za dodajanje kupona prosimo, pojdite na 'Marketing' - 'Marketinška orodja' - 'Kupon'.",
  // ==================== 其它  end      ==============
  ...slLocale
}


export default sl



// WEBPACK FOOTER //
// ./src/i18n/langs/sl.js